// 酒店七大类图标（icon / icon1 / icon2）统一用 2026-09 改版的线框图标，见 src/assets/img/category/
// （和 src/icons/svg/ 的同名文件是同一份，改图标两边一起改）。变量名沿用旧图片的名字，指向的已是新图标
import Group1 from "@/assets/img/category/sun.svg";
import Group2 from "@/assets/img/category/clean.svg";
import Group3 from "@/assets/img/category/bed.svg";
import Group4 from "@/assets/img/category/location.svg";
import Group5 from "@/assets/img/category/food.svg";
import Group6 from "@/assets/img/category/money.svg";
import Group7 from "@/assets/img/category/services.svg";
import Group1_1 from "@/assets/img/category/location.svg";
import Group2_1 from "@/assets/img/category/clean.svg";
import Group3_1 from "@/assets/img/category/bed.svg";
import Group4_1 from "@/assets/img/category/sun.svg";
import Group5_1 from "@/assets/img/category/services.svg";
import Group6_1 from "@/assets/img/category/food.svg";
import Group7_1 from "@/assets/img/category/money.svg";
import icon_FB from "@/assets/img/category/food.svg";
import icon_Amenities from "@/assets/img/category/sun.svg";
import icon_Cleanness from "@/assets/img/category/clean.svg";
import icon_Location from "@/assets/img/category/location.svg";
import icon_Room from "@/assets/img/category/bed.svg";
import icon_Service from "@/assets/img/category/services.svg";
import icon_Value from "@/assets/img/category/money.svg";
import icon_Brand from "@/assets/img/icon_Brand.png";
import img_english from "@/assets/img/img_english.png"
import img_chinese from "@/assets/img/img_chinese.png"
import img_German from "@/assets/img/img_German.png"
import img_Italian from "@/assets/img/img_Italian.png"
import Group8_1 from "@/assets/img/Group8_1.png";
import icon_Brand1 from "@/assets/img/icon_Brand1.png";
import global from '@/assets/img/global.png'
import APAC from '@/assets/img/APAC.png'
import CHINA from '@/assets/img/CHINA.png'
import EMEA from '@/assets/img/EMEA.png'
import N_A from '@/assets/img/N_A.png'
import MIDDLE_EAST from '@/assets/img/MIDDLE_EAST.png'
import AFRICA from '@/assets/img/AFRICA.png'
import SOUTH_AMERICA from '@/assets/img/SOUTH_AMERICA.png'
// 餐厅六大类同样换成 2026-09 的线框图标（src/assets/img/category/icon_*.svg，和 src/icons/svg/ 同名文件是同一份）
import Food_Quality from '@/assets/img/category/icon_Food_Quality.svg'
import Beverage_Quality from '@/assets/img/category/icon_Beverage_Quality.svg'
import Service_Quality from '@/assets/img/category/icon_Service_Quality.svg'
import Ambience from '@/assets/img/category/icon_Ambience.svg'
import Value_For_Money from '@/assets/img/category/icon_Value_For_Money.svg'
import Cleanliness from '@/assets/img/category/icon_Cleanliness.svg'
export default {
    // 模块加载状态（components/common/ModuleLoadState.vue）
    ModuleLoad: {
        loading: 'Loading…',
        slow: 'Taking longer than usual',
        failed: "Couldn't load this section",
        retry: 'Retry',
    },
    countryArr:[
        {
            name:'中文',
            value:'zh',
            icon:img_chinese
        },
        {
            name:'English',
            value:'en',
            icon:img_english
        },
        // {
        //     name:'Italian',
        //     value:'it',
        //     icon:img_Italian
        // },
        {
            name:'Deutsch',
            value:'de',
            icon:img_German
        },
    ],
    message: {
        coming_soon:'Coming soon',
        language: 'English',
        gmb:'A product by Where to know Insights GmbH',
        Settings_saved:'Settings saved',
        CurrentPassword:"Current password can't be blank",
        CurrentPassword1:"Password confirmation doesn't match the password",
        CurrentPassword2:"Password changed",
        sidebar:"Logged out successfully",
        competitors:'Please choose a hotel first',
        competitors1:'Server error. Please try again later',
        DateTimePickerHome: 'The end date cannot exceed the current date',
        DateTimePickerHome1: 'Could not load hotels. Please try again',
        DateTimePickerHome2: 'Choose at least one platform',
        platformOverview: 'File uploaded successfully',
        platformOverview1: 'File size cannot exceed 5MB',
        platformOverview2: 'Please upload a file first',
        login:'Please enter your username and password',
        login1:"login successfully",
        login2:"Login failed. The username or password is incorrect",
        login3:"The login request failed. Please try again later",
        Reviews:"There are no comments for the moment. Please re-filter",
        Reviews1:"Your login has expired. Log in now...",
        Reviews2:"Server error. Please try again later",
        Reviews3:"Network error. Please try again later",
        Exporting:"Exporting, please wait...",
        Download_ready:"Download ready",
        Export_failed:"Export failed",
        Export_no_evidence:"Exported without review evidence — you do not have review access",
        AI:"The Original content cannot be empty and cannot be translated",
        AI1:"The translation interface returns an exception. Please try again",
        AI2:"Translation failed. Please check your network or try again",
        AI3:"Copied to clipboard",
        AI4:"Copy failed. Please try again",
        AI5:"send successfully",
        AI6:"No translated content",
        AI7:"The target language was not obtained. Please try again",
        AI8:"Translation failed. Please try again",
        AI9:"Please write the original content, Sir",
        AI10:"Processing in progress. Please operate later",
        AI11:"Please select the translation language first",
        AI12:"Failed to get new AI content",
        FilterContainer:"The screening conditions have been applied",
        FilterContainer1:"The application operation has been cancelled",
        onlyTrans:'Please select the language',
        ReplyResponeRate:'At least one platform needs to be selected',
        LikeSuccess:'This reply has been saved. Please visit the reply template section later to view it.',
        LikeTooltip:'Please click "Generate" first',
        noLikeSuccess:'The collection has been successfully cancelled',
        requestFailed:'Request failed. Please try again.',
        noLikeTooltip:'Cancel collection',
        Saved_successfully:'Saved just now',
        Notes_saved:'Notes saved',
        Removed_from_Reply_Library:'Removed from Reply Library',
        Couldn_remove_from_Reply_Library:"Couldn’t remove from Reply Library",
    },
    sidebar: {
        replayGuide: 'Replay guide',
        language: 'Language',
        // 侧边栏 New 胶囊、品牌模式里拼出来的菜单名（集团名 / 品牌名是数据，只翻译固定部分）
        newBadge:'New',
        groupOverview:'{group} Overview',
        thailandLuxuryOverview:'Thailand Luxury Overview',
        brandDetails:'{brand} Details',
    },
    // Titles reuse the existing `menu` translations (menuKey below) so the tour
    // never drifts out of sync with the sidebar's own labels — only the
    // per-step description is new copy.
    sidebarGuide: {
        skip: 'Skip',
        prev: 'Previous',
        next: 'Next',
        finish: 'Done',
        steps: {
            hotelSelector: { title: 'Switch Hotel', desc: "Click your hotel's name to jump between every property you manage." },
            moduleSwitch: { title: 'Hotel / Restaurant Mode', desc: 'Switch between Hotel and Restaurant views — each has its own dashboard and menu.' },
            aiChat: { desc: "Ask questions in plain language and get instant, data-backed answers about your hotel's performance." },
            overview: { desc: "Your hotel's dashboard — platform ratings, response rate, recent reviews and the issues that need attention, at a glance." },
            reviews: { desc: 'Read and reply to every guest review, track flagged cases, and manage your reply templates.' },
            competition: { desc: 'See how you stack up against nearby competitors across OTA ratings and reviews.' },
            insights: { desc: 'Deeper reports and brand-level overviews to spot trends across your properties.' },
            surveys: { desc: 'Collect guest feedback during and after their stay with custom surveys.' },
            restaurantSelector: { title: 'Switch Restaurant', desc: "Click your restaurant's name to jump between every outlet you manage." },
            restaurantAiChat: { desc: "Ask questions in plain language and get instant, data-backed answers about your restaurant's performance." },
            restaurantOverview: { desc: "Your restaurant's dashboard — platform ratings, response rate, recent reviews, scores by area and staff and dish mentions." },
            restaurantReviews: { desc: 'Read and reply to every guest review, track flagged cases, and manage your reply settings and templates.' },
            restaurantCompetition: { desc: 'See how you compare with nearby restaurants across platform ratings and reviews.' },
            restaurantInsights: { desc: 'Monthly reports and longer-term reviews of how your restaurant is doing.' },
            generals: { desc: 'Manage account settings and find answers in the Help Center.' },
        },
    },
    // 新手导览名称（Help Center「Replay guide」列表，见 utils/guideTours.js）
    guideTours: {
        sidebar: 'Sidebar navigation',
        home: 'Hotel Overview',
        reviews: 'Reviews',
        restaurantReviews: 'F&B Reviews',
        restaurantSidebar: 'Sidebar navigation',
        restaurantHome: 'Restaurant Overview',
        skip: 'Skip',
        prev: 'Previous',
        next: 'Next',
        finish: 'Done',
    },
    restaurantHomeGuide: {
        steps: {
            platforms: { title: 'Platform Overview', desc: "Each platform's rating, response rate and average response time — and roughly how many perfect-score reviews it takes to reach your target." },
            activity: { title: 'Recent Activity & Top Lists', desc: '"{recent}" shows reviews from the last 72 hours — switch Type to see what guests praised or complained about. "{topLists}" ranks last month\'s most-mentioned strengths and issues.' },
            filters: { title: 'Platforms & Period', desc: 'Pick platforms and a period — every score and list below updates to match.' },
            scores: { title: 'Scores', desc: 'Your overall score and each area — food, beverage, service and more. Hover over the eye icon for positive / neutral / negative counts, and click it for the sub-categories.' },
            attention: { title: '{areasWarning}', desc: 'Sub-categories that are pulling your score down. When everything is performing well, this stays empty.' },
            competitors: { title: 'Competitors', desc: 'How your overall score compares with the competitors you track.' },
            mentions: { title: 'Staff & F&B Mentions', desc: 'The staff members, dishes and drinks guests mention most, and how positive those mentions are. Click a row to read the reviews.' },
        },
    },
    reviewsGuide: {
        steps: {
            period: { title: 'Period', desc: 'Pick a period or exact dates — the platform cards and the review list below update together.' },
            tools: { title: 'Search, Filters & Export', desc: 'Search review text, switch the list layout, filter by score, review type, sentiment or category, and export the reviews you are looking at.' },
            platforms: { title: 'Platforms', desc: "Each card shows the platform's average score and review count for this period. Click a card to show or hide that platform's reviews." },
            card: { title: 'Review Details', desc: 'Each card is one review. Tags like "{mismatch}" flag reviews worth a closer look, and "{goTo}" opens the original. Click {expand} for the full analysis — let\'s open this one.' },
            score: { title: 'WQI Score', desc: 'The AI score of what the guest actually wrote, from 1 to 10 (5-point platforms are converted). Hover over it to see the color scale.' },
            translate: { title: 'Translation', desc: 'Pick a language to translate the review, and switch between the translation and the original here.' },
            guestTags: { title: 'Guest Tags', desc: '"{guestTags}" are the details the guest picked on the platform when posting — food, service and atmosphere ratings, group size, noise level and more. You can filter reviews by them in Filters.' },
            analysis: { title: 'AI Analysis', desc: '"{dimensions}" shows which topics the review covers, how much of it each takes up and how each scored. "{summary}" sums the review up in a line.' },
            note: { title: 'Notes', desc: 'Leave an internal note for your team. It stays in WTK and is never posted to the platform.' },
            actions: { title: 'Forward & Reply', desc: '"{forward}" emails the review to a colleague. "{reply}" drafts an AI reply based on your {replySetting} — edit it and copy it to the platform.' },
            actionsGoogle: { title: 'Forward & Reply', desc: '"{forward}" emails the review to a colleague. "{reply}" drafts an AI reply based on your {replySetting} — edit it, copy it, or post it straight to Google.' },
            actionsReplied: { title: 'Forward & Reply', desc: '"{forward}" emails the review to a colleague. This one has already been answered, so its button shows "{replied}"; on reviews you haven\'t answered, "{reply}" drafts an AI reply based on your {replySetting} for you to edit and copy to the platform.' },
        },
    },
    homeGuide: {
        skip: 'Skip',
        prev: 'Previous',
        next: 'Next',
        finish: 'Done',
        steps: {
            overview: { title: 'Dashboard Overview', desc: "This summarizes your platform's overall performance — response rate, last 24 hours activity, and last week's highlights and issues — so you can see your hotel's recent status at a glance." },
            dateRange: { title: 'Time Range', desc: 'Switch the date range and review platforms here — every chart and metric below updates automatically to match what you select.' },
            needsAttention: { title: 'Issues Needing Attention', desc: 'Lists the subcategories most worth watching by review count, score and impact — click any row for its full detail.' },
            highlights: { title: 'Strengths & Improvements', desc: "Toggle between Strengths and Issues to see last week's most-mentioned positive keywords and the ones that need improvement." },
            evidence: { title: 'View Original Reviews', desc: 'Click any category card below (Location, Cleanliness, etc.) to open the original guest reviews behind that score.' },
        },
    },
    // 404 页（views/error/404.vue）
    NotFound:{
        desc:"Sorry, the page you are looking for doesn't exist",
        backHome:"Back to home",
    },
    menu:{
        // Quality Standards 页：侧栏用短名，页面头部用全称。
        'Quality Standards': 'Quality Standards',
        // 新版 WTK Luxury Standards 的侧栏名（只给 featureGates.js 的 LUXURY_STANDARDS_HOTELS）。页面本身只有英文
        'Luxury Standards': 'Luxury Standards',
        // 半年报两个侧栏入口（RouterMenu.vue）。de / it 暂用英文
        'Market Signals': 'Market Signals',
        'Half-Year Review': 'Half-Year Review',
        // 酒店那份半年报改名 Period Review（周期长度会变，名字里不写时长）；F&B 仍用上面那条
        'Period Review': 'Period Review',
        QualityStandards_Title: 'Guest Feedback & Quality Standards',
        QualityStandards_EmptyTitle: 'No standards data for this property',
        QualityStandards_EmptyDesc: "This property isn't covered by the current LQA / Forbes / MICHELIN dataset. Pick a covered property from the hotel switcher to see its findings.",
        'Hotel Overview': 'Hotel Overview',
        'Hotel Dashboard': 'Hotel Dashboard',
        'Reports': 'Reports',
        'PortiolioBriefing': 'Portfolio Briefing',
        BrandOverview:'Brand Overview',
        BrandOverview2:'Portfolio Insights',
        // Brand-mode sidebar's brand-list entry under "Hotel Reviews" — deliberately
        // its own key even though the English text happens to match 'BrandOverview'
        // above, since that key is tied to the older, separate /BrandOverview page.
        BrandOverviewList:'Brand Overview',
        'Restaurant Dashboard': 'Restaurant Dashboard',
        'Reviews & Reply': 'Reviews & Reply',
        'Reviews': 'Reviews',
        'ReplyLike': 'Reply Template',
        'Replies': 'Replies',
        'Reply Setting': 'Reply Setting',
        'Competitors' : 'Competitors',
        'Settings' : 'Settings',
        'Restaurant' : 'Restaurant',
        'Help Center (FAQ)':'Help Center (FAQ)',
        'AI Chat':'Intelligence',

        'Dashboards': 'Dashboards',
        'dashboard': 'dashboard',
        'Restaurant Overview': 'Restaurant Overview',
        'Reviews & Replies': 'Case Management',
        'Case Management': 'Case Management',
        'Hotel': 'Hotel',
        // Sidebar Hotel/F&B/Brand tab switcher only — deliberately not reusing
        // 'Restaurant' above, which other menu labels still rely on as-is.
        'F&B': 'F&B',
        'Brand': 'Brand',
        'Hotel Reviews': 'Hotel Reviews',
        'Restaurant Reviews': 'Restaurant Reviews',
        'Hotel Reply Setting': 'Hotel Reply Setting',
        'Hotel Reply Template': 'Hotel Reply Template',
        'Food & Beverage': 'Food & Beverage',
        'F&B Reviews': 'F&B Reviews',
        'F&B Reply Setting': 'F&B Reply Setting',
        'F&B Reply Template': 'F&B Reply Template',
        'Competition': 'Competition',
        'Hotel Competitors': 'Hotel Competitors',
        'Restaurant Competitors': 'Restaurant Competitors',
        'Competitors_OTA_Reports': 'Market Overview',
        'Competitors_Benchmarks': 'Competitor Benchmark',
        'Insights':'Insights',
        'Brand Overview':'Brand Overview',
        'Generals':'Generals',
        'Setting':'Settings',
        'Survey':'Survey',
        'Surveys':'Surveys',
        'During Stay':'During Stay',
        'Post Stay':'Post Stay',
        'Survey Detail':'Survey Detail',
        'Needs Attention':'Needs Attention',
        'Reply Library':'Reply Library',
        'Staff Management':'Staff Management',
        'Connections':'Connections',
        // 品牌模式侧栏的 Active Signal Details 入口
        ActiveSignalDetails:'Active Signal Details',
    },
    DateMonth:{
        Jan: 'January',
        Feb: 'February',
        Mar: 'March',
        Apr: 'April',
        May: 'May',
        Jun: 'June',
        Jul: 'July',
        Aug: 'August',
        Sep: 'September',
        Oct: 'October',
        Nov: 'November',
        Dec: 'December'
    },
    Filter:'Filter',
    Date:'Date',
    SML_ReviewsShowBox:{
        emptyState:{
            title:'No matching reviews',
            description:'No reviews match the current filters. Try adjusting or resetting them.',
            resetBtn:'Reset Filters',
        },
    },
    inputPlaceholder:"Input",
    selectPlaceholder:"Select",
    Frequency:"Frequency",
    Example:'Example：',
    Sort:'Sort',
    Score:'Score',
    WTK_Score:'WQI',
    Time:'Time',
    Email:'Email',
    Proportion:'Proportion',
    No_of_reviews:'No. of reviews',
    No_data:'No data',
    NA:'N/A',
    average:'Average',
    reviewsAvg:'Review Avg',
    Diff:'Diff',
    Hotel:'Hotel',
    Restaurant:'Restaurant',
    Reviews:"Reviews",
    Review:"Review",
    Reply:"Reply",
    Edit:"Edit",
    Add:"Add",
    engagements:"Engagements",
    Submit:"Submit",
    Title:"Title",
    show_details:'Show details',
    Loading:'Loading',
    Load_failed:'Fail to load',
    Report_not_ready:'Report not ready yet',
    Report_not_ready_desc:'This period has not reached its generation time, or the data is still being processed. Please check back later.',
    Retry_after_refreshing:'Retry after refreshing',
    LoadingData:'Loading data',
    LoadingNewData:'Loading new data',
    LoadingInitialData:'Loading initial data',
    Category:'Category',
    copySuccess:'Copied!',
    Global:'Global',
    Show_All:'Show All',
    SubcategoryAttention_title:'Areas Warning',
    SubcategoryAttention_tooltip:'Subcategories scoring below 8.0, ranked by overall impact. Reviews shows neutral + negative count. Impact = (subcategory score − overall score) × review weight, measuring how much each area drags down or lifts the total score.',
    SubcategoryAttention_empty:'All subcategories are performing well.',
    echartsNoData1:'No data available for this period',
    echartsNoData2:'Try selecting another date range or check back later once new data is available',
    // WTK-578 图表空状态按原因区分（EchartsNoData 的 reason）
    echartsNoData_noScored1:'No scored reviews in this period',
    echartsNoData_noScored2:'The trend only plots periods that have rated reviews. Try a longer date range, such as Current Quarter.',
    echartsNoData_noCategory1:'No reviews mentioned {category} in this period',
    echartsNoData_noCategory2:'Switch back to Overall score, or try a longer date range such as Current Quarter.',
    CategoryObj:{
        "Location & Neighborhood":"Location & Neighbourhood",
        'Location & Neighbourhood':'Location & Neighbourhood',
        Location:'Location & Neighbourhood',

        "Cleanness":"Cleanliness",
        "Cleanliness":"Cleanliness",

        "Room Facilities & Comfort":"Room Comfort",
        "Room Comfort":"Room Comfort",
        'Room & Amenities':'Room & Amenities',
        Room:'Room Comfort',

        'Hotel Atmosphere & Design':'Hotel Atmosphere & Design',
        "Hotel Amenities & Atmosphere":"Hotel Amenities & Atmosphere",
        'Hotel Facilities & Amenities':'Hotel Facilities & Amenities',
        Amenities:'Hotel Amenities & Atmosphere',

        "Food & Beverage":"Food & Beverage",
        'F&B Experience':'F&B Experience',
        "F & B":"Food & Beverage",
        "F&B":"Food & Beverage",

        "Guest Experience & Service":"Guest Experience & Service",
        Services:'Guest Experience & Service',
        Service:'Guest Experience & Service',

        "Value for Money":"Value for Money",
        Value:'Value for Money',

        'Brand Consistency & Expression':'Brand Consistency & Expression',
        Brand:'Brand',
        "Food Quality":"Food Quality",
        "Beverage Quality":"Beverage Quality",
        "Service Quality":"Service Quality",
        "Ambience":"Ambience",
        "Cleanliness":"Cleanliness",
        "Value For Money":"Value For Money",
        "Value Perception":"Value For Money",
    },
    CategoryLabel:[
        {
            name1:"Overall score",
            name2:"Overall score",
            icon:'',
            icon1:'',
            value:"total",
            value1:"total",
            value2:"total",
        },
        {
            name1:"Location",
            name2:"Location & Neighbourhood",
            icon2:Group4,
            icon1:icon_Location,
            icon:Group1_1,
            value:"Location",
            value1:"location_neighbourhood",
            value2:"Location & Neighbourhood",
        },
        {
            name1:"Cleanliness",
            name2:"Cleanliness",
            icon2:Group2,
            icon1:icon_Cleanness,
            icon:Group2_1,
            value:"Cleanness",
            value1:"cleanliness",
            value2:"Cleanliness",
        },
        {
            name1:"Room",
            name2:"Room Comfort",
            icon2:Group3,
            icon1:icon_Room,
            icon:Group3_1,
            value:"Room",
            value1:"room_comfort",
            value2:"Room Comfort",
        },
        {
            name1:"Hotel Amenities",
            name2:"Hotel Amenities & Atmosphere",
            icon2:Group1,
            icon1:icon_Amenities,
            icon:Group4_1,
            value:"Amenities",
            value1:"hotel_amenities_atmosphere",
            value2:"Hotel Amenities & Atmosphere",
        },
        {
            name1:"F & B",
            name2:"Food & Beverage",
            icon2:Group5,
            icon1:icon_FB,
            icon:Group6_1,
            value:"F & B",
            value1:"food_beverage",
            value2:"Food & Beverage",
        },
        {
            name1:"Service",
            name2:"Guest Experience & Service",
            icon2:Group7,
            icon1:icon_Service,
            icon:Group5_1,
            value:"Service",
            value1:"guest_experience_service",
            value2:"Guest Experience & Service",
        },
        {
            name1:"Value",
            name2:"Value for Money",
            icon2:Group6,
            icon1:icon_Value,
            icon:Group7_1,
            value:"Value",
            value1:"value_for_money",
            value2:"Value for Money",
        },
        {
            name1:"Food Quality",
            name2:"Food Quality",
            icon2:Food_Quality,
            icon1:Food_Quality,
            icon:Food_Quality,
            value:"Food Quality",
            value1:"food_quality",
            value2:"Food Quality",
        },
        {
            name1:"Beverage Quality",
            name2:"Beverage Quality",
            icon2:Beverage_Quality,
            icon1:Beverage_Quality,
            icon:Beverage_Quality,
            value:"Beverage Quality",
            value1:"beverage_quality",
            value2:"Beverage Quality",
        },
        {
            name1:"Service Quality",
            name2:"Service Quality",
            icon2:Service_Quality,
            icon1:Service_Quality,
            icon:Service_Quality,
            value:"Service Quality",
            value1:"service_quality",
            value2:"Service Quality",
        },
        {
            name1:"Ambience",
            name2:"Ambience",
            icon2:Ambience,
            icon1:Ambience,
            icon:Ambience,
            value:"Ambience",
            value1:"ambience",
            value2:"Ambience",
        },
        {
            name1:"Value For Money",
            name2:"Value For Money",
            icon2:Value_For_Money,
            icon1:Value_For_Money,
            icon:Value_For_Money,
            value:"Value For Money",
            value1:"value_for_money",
            value2:"Value For Money",
        },
        {
            name1:"Cleanliness",
            name2:"Cleanliness",
            icon2:Group2,
            icon1:Cleanliness,
            icon:Group2_1,
            value:"Cleanliness",
            value1:"cleanliness",
            value2:"Cleanliness",
        },
    ],
    CategoryLabel1:[
        {
            name1:"Overall score",
            name2:"Overall score",
            icon:'',
            icon1:'',
            value:"total",
            value1:"total",
        },
        {
            name1:"Location",
            name2:"Location & Neighbourhood",
            icon2:Group4,
            icon1:icon_Location,
            icon:Group1_1,
            value:"Location",
            value1:"location_neighbourhood",
        },
        {
            name1:"Cleanliness",
            name2:"Cleanliness",
            icon2:Group2,
            icon1:icon_Cleanness,
            icon:Group2_1,
            value:"Cleanness",
            value1:"cleanliness",
        },
        {
            name1:"Room",
            name2:"Room Comfort",
            icon2:Group3,
            icon1:icon_Room,
            icon:Group3_1,
            value:"Room",
            value1:"room_comfort",
        },
        {
            name1:"Hotel Amenities",
            name2:"Hotel Amenities & Atmosphere",
            icon2:Group1,
            icon1:icon_Amenities,
            icon:Group4_1,
            value:"Amenities",
            value1:"hotel_amenities_atmosphere",
        },
        {
            name1:"F & B",
            name2:"Food & Beverage",
            icon2:Group5,
            icon1:icon_FB,
            icon:Group6_1,
            value:"F & B",
            value1:"food_beverage",
        },
        {
            name1:"Service",
            name2:"Guest Experience & Service",
            icon2:Group7,
            icon1:icon_Service,
            icon:Group5_1,
            value:"Service",
            value1:"guest_experience_service",
        },
        {
            name1:"Value",
            name2:"Value for Money",
            icon2:Group6,
            icon1:icon_Value,
            icon:Group7_1,
            value:"Value",
            value1:"value_for_money",
        },
        {
            name1:"Brand",
            name2:"Brand Consistency & Expression",
            icon2:icon_Brand,
            icon1:icon_Brand,
            icon:Group8_1,
            value:"Brand",
            value1:"brand_consistency_expression",
        },
        {
            name1:"Cleanliness",
            name2:"Cleanliness",
            icon2:Group2,
            icon1:icon_Cleanness,
            icon:Group2_1,
            value:"Cleanliness",
            value1:"cleanliness",
        },
    ],
    RestaurantObj:{
        'Food Quality':'Food Quality',
        'Taste & Flavor':'Taste & Flavor',
        'Freshness':'Freshness',
        'Temperature':'Temperature',
        'Portion Size':'Portion Size',
        'Food Presentation':'Food Presentation',
        'Menu Variety':'Menu Variety',
        'Innovation & Uniqueness':'Innovation & Uniqueness',
        'General': 'General',
        "View & Scenery":"View & Scenery",
        "Beverage Quality":"Beverage Quality",
        "Taste & Preparation":"Taste & Preparation",
        "Mixology Skill":"Mixology Skill",
        "Alcohol Selection":"Alcohol Selection",
        "Non-Alcohol Selection":"Non-Alcohol Selection",
        "Drink Presentation":"Drink Presentation",
        "Drink Menu & Variety":"Drink Menu & Variety",
        "Drink Innovation & Uniqueness":"Drink Innovation & Uniqueness",

        'Service Quality':'Service Quality',
        'Professionalism':'Professionalism',
        'Efficiency':'Efficiency',
        'Accuracy':'Accuracy',
        'Personalization':'Personalization',
        'Problem Resolution':'Problem Resolution',
        'Staffing & Team Coordination':'Staffing & Team Coordination',
        'Bartender':'Bartender',
        'Reservation & Waiting':'Reservation & Waiting',
        'Access, Arrival & Seating':'Access, Arrival & Seating',
        'Guest Safety & Fair Treatment':'Guest Safety & Fair Treatment',

        "Ambience":'Ambience',
        "Decor & Design":'Decor & Design',
        "Lighting":'Lighting',
        "Music & Noise":'Music & Noise',
        "Air Quality":'Air Quality',
        "Temperature & Ventilation":'Temperature & Ventilation',
        "Privacy":'Privacy',
        "Seating Comfort":'Seating Comfort',
        "Atmosphere":'Atmosphere',
        "Facilities & Maintenance":'Facilities & Maintenance',

        "Cleanliness":'Cleanliness',
        "Tableware Hygiene":'Tableware Hygiene',
        "Dining Area":'Dining Area',
        "Restroom":'Restroom',
        "Staff Appearance":'Staff Appearance',
        "Kitchen & Food Handling":'Kitchen & Food Handling',
        "Pest Control":'Pest Control',

        "Value Perception":'Value For Money',
        "Overall Worthiness":'Overall Worthiness',
        "Quality & Service vs Price":'Quality & Service vs Price',
        "Portion vs Price":'Portion vs Price',
        "Overall Satisfaction / Disappointment":'Overall Satisfaction / Disappointment',
        "Perceived Value vs Expectation":'Perceived Value vs Expectation',
        "Price Transparency & Charging":'Price Transparency & Charging',
    },
    OTAs:{
        HOLIDAYCHECK:'HolidayCheck',
        HRS:'HRS',
        LASTMINUTE:'lastminute.com',
        TRIVAGO:'trivago',
        PRICELINE:'Priceline',
        HOTELSCOM:'Hotels.com',
        HOTELESCOM:'Hoteles.com',
        RAKUTEN:'Rakuten Travel',
        TRAVELOKA:'Traveloka',
        HOSTELWORLD:'Hostelworld',
        TRAVELOCITY:'Travelocity',
        ORBITZ:'Orbitz',
        LUXURYESCAPES:'Luxury Escapes',
        INTERNAL:'Internal',
        Internal:'Internal',
        MAKEMYTRIP:'MakeMyTrip',
        HOTELDE:'hotel.de',
        HolidayCheck:'HolidayCheck',
        Lastminute:'lastminute.com',
        Trivago:'trivago',
        Priceline:'Priceline',
        Hotelscom:'Hotels.com',
        Rakuten:'Rakuten Travel',
        Traveloka:'Traveloka',
        Hostelworld:'Hostelworld',
        Travelocity:'Travelocity',
        Orbitz:'Orbitz',
        LuxuryEscapes:'Luxury Escapes',
        MakeMyTrip:'MakeMyTrip',
        HotelDe:'hotel.de',
        BOOKING:'Booking.com',
        TRIP:'Ctrip.com',
        EXPEDIA:'Expedia',
        GOOGLE:'Google',
        TRIPADVISOR:'Tripadvisor',
        OPENTABLE:'OpenTable',
        YELP:'Yelp',
        WONGNAI:'Wongnai',
        AGODA:'Agoda',
        agoda:'Agoda',
        Booking:'Booking.com',
        Trip:'Ctrip.com',
        Google:'Google',
        Expedia:'Expedia',
        Tripadvisor:'Tripadvisor',
        Yelp:'Yelp',
        Wongnai:'Wongnai',
        'Google Map':'Google Map',
        'Open Table':'Open Table',
        'OpenTable':'Open Table',
    },
    baseLanguages:[
        { label: "English", value: "English" },
        { label: "German", value: "German" },
        { label: "French", value: "French" },
        { label: "Italian", value: "Italian" },
        { label: "Spanish", value: "Spanish" },
        { label: "Portuguese", value: "Portuguese" },
        { label: "Swedish", value: "Swedish" },
        { label: "Chinese", value: "Chinese" },
        { label: "Japanese", value: "Japanese" },
        { label: "Korean", value: "Korean" },
        { label: "Arabic", value: "Arabic" },
        { label: "Russian", value: "Russian" },
        { label: "Turkish", value: "Turkish" },
        { label: "Thai", value: "Thai" },
        { label: "Vietnamese", value: "Vietnamese" },
        { label: "Indonesian / Bahasa", value: "Indonesian / Bahasa" },
        { label: "Dutch", value: "Dutch" },
        { label: "Polish", value: "Polish" },
        { label: "Greek", value: "Greek" },
        { label: "Hebrew", value: "Hebrew" },
    ],
    TravellerType:{
        "Couple":"Couple",
        "Solo":"Solo",
        "Group":"Group",
        "Family":"Family",
        "Business":"Business",
        "unknown":"Unknown",
        "Unknown":"Unknown",
        "UNKNOWN":"Unknown",
        "FAMILY":"Family",
        "COUPLE":"Couple",
        "SOLO":"Solo",
        "GROUP":"Group",
        "BUSINESS":"Business",
    },
    punctuationMarks:{
        quotationMarks1:' " ',
        quotationMarks2:' " ',
    },
    subCategories:{
        local_cultural_expression:'Local cultural expression',
        accessibility:"Accessibility",
        neighbourhood_facilities:"Neighbourhood facilities",
        safety:"Safety",
        views:"Views",

        room_hygiene:"Room hygiene",
        bathroom_hygiene:"Bathroom hygiene",
        public_area_hygiene:"Public area hygiene",
        odour:"Odour",
        restaurant_cleanness:"Restaurant cleanness",

        bed_quality:"Bed quality",
        sound_insulation:"Sound insulation",
        air_conditioning_heating:"Air conditioning/heating",
        room_size:"Room size",
        lighting:"Lighting",
        shower_water_pressure:"Shower water pressure",
        room_design:"Room design",
        room_maintenance:"Room maintenance",
        in_room_amenities:"In-room amenities",

        wifi_internet:"Wi-Fi & Internet",
        // toKey("Wi-Fi & Internet") 得到的是 wi_fi_internet(连字符也会变成下划线),
        // 和上面那个历史 key 对不上,两个都留着。
        wi_fi_internet:"Wi-Fi & Internet",
        gym:"Gym",
        swimming_pool:"Swimming pool",
        spa:"Spa",
        elevator:"Elevator",
        business_centre:"Business centre",
        meeting_rooms:"Meeting rooms",
        car_parking:"Car parking",
        executive_lounge:"Executive Lounge",
        hotel_atmosphere_design:"Hotel Atmosphere & Design",
        beach_outdoor_areas:"Beach & outdoor areas",
        kids_family_facilities:"Kids & family facilities",

        breakfast:"Breakfast",
        restaurant:"Restaurant",
        bar:"Bar",
        coffee_beverages:"Coffee & Beverages",
        in_room_dining:"In-room dining",
        service_and_efficiency:"Service and efficiency",

        booking:"Booking",
        membership_benefits:"Membership benefits",
        // special_request_handling:"Special request handling",
        personalised_request_handling:"Personalised Request Handling",
        personalised_service:"Personalised Service",
        // front_desk_concierge:"Front desk & Concierge",
        concierge:"Concierge",
        check_in:"Check in",
        check_out:"Check out",
        in_room_request:"In-room request",
        housekeeping:"Housekeeping",
        // cleaning_tidying:"Cleaning & Tidying",
        flexibility_guest_needs:"Flexibility of guest needs",
        flexibility_of_guest_needs:"Flexibility of guest needs",
        butler_service:"Butler service",
        hotel_transportation:"Hotel Transportation",
        complaints_feedback:"Complaints & Feedback",
        guest_treatment_fairness:"Guest Treatment Fairness",
        lounge_service:"Lounge service",
        spa_gym_pool_service:"SPA & GYM & Pool service",
        billing:"Billing",
        points_arrival_speed:"Points arrival speed",
        customer_service_response:"Customer service response",
        communication_language:"Communication & Language",
        security_safety:"Security & Safety",

        price_fairness:"Price fairness",
        experience_matching_price:"Experience matching price",
        hidden_fees:"Hidden fees",
        promotions_membership_benefits:"Promotions & Membership Benefits",
        overall_satisfaction:"Overall satisfactions or disappointments",
        // 接口在 Value for Money 下实际返回的是这个全称 key,SUBCATEGORY_MAP 里
        // 没有对应项,所以只能在这里单独补(缺了它界面会直接显示 i18n 路径原文)。
        overall_satisfactions_or_disappointments:"Overall satisfactions or disappointments",

        general:'General',
    },
    login:{
        Open_in_app_tip:'Viewing this page on mobile may affect your experience. Open the app instead?',
        Open_in_app_title:'Continue to Where to Know?',
        Open_in_app_subtitle:'This page works best in the Where to Know app',
        Open_in_app_button:'Open App',
        Reset_your_password:'Reset your password',
        Email_address:'Email address',
        Log_in:'Log in',
        Reset_password:'Reset password',
        Log_in_to_start_your_session:'Sign in to your account',
        placeholder1:'Email address',
        placeholder2:'Password',
        Remember_me:'Remember me',
        module_hotel:'Hotel',
        module_restaurant:'Restaurant',
        module_brand:'Brand',
        Forget_your_password:'Forget your password?',
        Back_to_login:'Back to login',
        Send_reset_link:'Send reset link',
        Password_requirements:'Password requirements:',
        Password_requirements1:'must include a number, a capital letter,',
        Password_requirements2:'and a lowercase letter',
        Verify_your_email:'Verify your email',
        Verify_your_email1:"We've emailed you a six digit signup code",
        Verify_your_email2:"Enter the code below",
        Email_me_another_verification_code:"Email me another verification code",
        Repeat_new_password:"Repeat new password",
        Are_you_sure_you_want_to_logout:'Are you sure you want to logout',
        Confir_Logout:'Confirm Logout',
        Confirm:'Confirm',
        Cancel:'Cancel',
        Current_password_is_incorrect:'Current password is incorrect',
    },
    Region:[
        {
            label:'Global',
            value:'GLOBAL',
            icon1:global,
        },
        {
            label:'Greater China',
            value:'GREATER_CHINA',
            icon1:CHINA,
        },
        {
            label:'APAC ex China',
            value:'APAC_EX_CHINA',
            icon1:APAC,
        },
        {
            label:'Middle East',
            value:'MIDDLE_EAST',
            icon1:MIDDLE_EAST,
        },
        {
            label:'Europe',
            value:'EUROPE',
            icon1:EMEA,
        },
        {
            label:'Africa',
            value:'AFRICA',
            icon1:AFRICA,
        },
        {
            label:'North America',
            value:'NORTH_AMERICA',
            icon1:N_A,
        },
        {
            label:'South America',
            value:'SOUTH_AMERICA',
            icon1:SOUTH_AMERICA,
        },
    ],

    geo:{
        global:'Global',
        americas:'Americas',
        north_america:'North America',
        latin_america:'Latin America',
        emea:'EMEA',
        europe:'Europe',
        middle_east:'Middle East',
        africa:'Africa',
        apac:'APAC',
        southeast_asia:'Southeast Asia',
        japan:'Japan',
        korea:'Korea',
        australia_pacific:'Australia & Pacific',
        india:'India & South Asia',
        greater_china:'Greater China',
        mainland_china:'Mainland China',
        hong_kong:'Hong Kong',
        taiwan:'Taiwan',
        macau:'Macau',
        countries:{
            'United States':'USA',
            'USA':'US',
            'Canada':'Canada',
            'Mexico':'Mexico',
            'Brazil':'Brazil',
            'Argentina':'Argentina',
            'Chile':'Chile',
            'Colombia':'Colombia',
            'Peru':'Peru',
            'Costa Rica':'Costa Rica',
            'Panama':'Panama',
            'Dominican Republic':'Dominican Republic',
            'Puerto Rico':'Puerto Rico',
            'Jamaica':'Jamaica',
            'Bahamas':'Bahamas',
            'Bermuda':'Bermuda',
            'United Kingdom':'UK',
            'UK':'UK',
            'France':'France',
            'Germany':'Germany',
            'Italy':'Italy',
            'Spain':'Spain',
            'Netherlands':'Netherlands',
            'Switzerland':'Switzerland',
            'Austria':'Austria',
            'Belgium':'Belgium',
            'Portugal':'Portugal',
            'Sweden':'Sweden',
            'Norway':'Norway',
            'Denmark':'Denmark',
            'Finland':'Finland',
            'Ireland':'Ireland',
            'Greece':'Greece',
            'Czech Republic':'Czech Republic',
            'Poland':'Poland',
            'Hungary':'Hungary',
            'Croatia':'Croatia',
            'Romania':'Romania',
            'Turkey':'Turkey',
            'Russia':'Russia',
            'Luxembourg':'Luxembourg',
            'Monaco':'Monaco',
            'Malta':'Malta',
            'Cyprus':'Cyprus',
            'Iceland':'Iceland',
            'Georgia':'Georgia',
            'UAE':'UAE',
            'United Arab Emirates':'UAE',
            'Saudi Arabia':'Saudi Arabia',
            'Qatar':'Qatar',
            'Bahrain':'Bahrain',
            'Kuwait':'Kuwait',
            'Oman':'Oman',
            'Jordan':'Jordan',
            'Lebanon':'Lebanon',
            'Israel':'Israel',
            'Egypt':'Egypt',
            'South Africa':'South Africa',
            'Morocco':'Morocco',
            'Kenya':'Kenya',
            'Tanzania':'Tanzania',
            'Nigeria':'Nigeria',
            'Ghana':'Ghana',
            'Ethiopia':'Ethiopia',
            'Rwanda':'Rwanda',
            'Mauritius':'Mauritius',
            'Seychelles':'Seychelles',
            'Thailand':'Thailand',
            'Singapore':'Singapore',
            'Vietnam':'Vietnam',
            'Indonesia':'Indonesia',
            'Malaysia':'Malaysia',
            'Philippines':'Philippines',
            'Myanmar':'Myanmar',
            'Cambodia':'Cambodia',
            'Laos':'Laos',
            'Japan':'Japan',
            'South Korea':'South Korea',
            'Korea':'Korea',
            'Australia':'Australia',
            'New Zealand':'New Zealand',
            'Fiji':'Fiji',
            'Papua New Guinea':'Papua New Guinea',
            'Guam':'Guam',
            'French Polynesia':'French Polynesia',
            'Maldives':'Maldives',
            'India':'India',
            'Sri Lanka':'Sri Lanka',
            'Nepal':'Nepal',
            'Bangladesh':'Bangladesh',
            'Pakistan':'Pakistan',
            'China':'China',
            'Hong Kong':'Hong Kong',
            'Taiwan':'Taiwan',
            'Taiwan (China)':'Taiwan (China)',
            'Macau':'Macau',
            'Mongolia':'Mongolia',
        },
        cities:{
            'Bangkok':'Bangkok',
            'Koh Samui':'Koh Samui',
            'Phang Nga':'Phang Nga',
            'Chiang Mai':'Chiang Mai',
            'Hua Hin':'Hua Hin',
            'Khao Yai':'Khao Yai',
            'Pattaya':'Pattaya',
            'Phuket':'Phuket',
            'Ko Chang':'Ko Chang',
        },
    },

    selectHotel:{
        Select_Your_Hotel:"Select Your Hotel",
        Select_Your_Restaurant:"Select Your Restaurant",
        Select_Your_Brand:"Select Your Brand",
        Choose_any_of_the_following_hotels:"Choose a hotel to continue",
        Choose_a_restaurant_to_continue:"Choose a restaurant to continue",
        Choose_a_brand_to_continue:"Choose a brand to continue",
        Loading_hotels:"Loading hotels",
        Confirm_Continue:"Confirm & Continue",
        Need_assistance_Contact_support:"Need assistance? Contact support",
    },
    current:{
        Date:"Today's Date:",
        Updated:"Local Time:",
    },
    chat:{
        title:'Intelligence',
        welcomeTitle:'Ask me anything about your review data',
        welcomeSub:'Analytics assistant · Beta',
        betaNotice:'AI-generated responses should be reviewed alongside your dashboard data.',
        betaNoticeL1:'The AI assistant is still in beta and responses may occasionally be inaccurate.',
        betaNoticeL2:'Always verify important insights against your dashboard data.',
        betaBadge:'AI Assistant (Beta)',
        quotaWarnDay:"You've used about {pct}% of this hotel's AI assistant capacity for today — it resets tomorrow.",
        quotaWarnMonth:"You've used about {pct}% of this hotel's AI assistant capacity for this month — it resets on the 1st.",
        thinking:'Reasoning',
        steps:'Steps ({n})',
        analyzing:'Analyzing reviews…',
        newChat:'New chat',
        delete:'Delete',
        deleteConfirm:'Delete this conversation? This cannot be undone.',
        deleted:'Conversation deleted',
        feedbackUp:'Helpful',
        feedbackDown:'Not helpful',
        copy:'Copy',
        copied:'Copied',
        copyFailed:'Copy failed',
        unknownUser:'Unknown user',
        byAuthor:'by {name}',
        groupToday:'Today',
        groupYesterday:'Yesterday',
        groupLast7:'Previous 7 days',
        groupLast30:'Previous 30 days',
        groupOlder:'Older',
        insightsTitle:'{n} items worth reviewing this week',
        insightsBadge:'Attention Summary',
        insightsUrgent:'{n} high priority',
        insightsCta:'What should I focus on?',
        periodSwitch:'Period:',
        period7d:'Last 7 days',
        periodMonth:'This month',
        periodQuarter:'This quarter',
        periodYtd:'Year to date',
        samePeriod:'Same question for {period}',
        insightsView:'Ask AI',
        insightsAsk:'What anomalies were flagged for us recently? Walk me through them and what to do.',
        evidence:'Sources',
        hideEvidence:'Hide',
        evidenceHint:'Click the “Sources” tag under any answer to see what it’s based on.',
        viewReportPdf:'Open report PDF',
        reportPdfError:'Could not open the report PDF. Please try again.',
        evReviews:'Reviews',
        evReports:'Reports',
        evWeb:'Web',
        viewOnSource:'View original',
        viewSource:'View source',
        expandReview:'Show more',
        collapseReview:'Show less',
        placeholder:'Type a question — Enter to send (Shift+Enter for newline)',
        suggestions:[
            'Anything unusual I should know about?',
            'Why did our reviews get worse this month?',
            'Are we hitting our goals this month?',
            'How do we stack up against competitors?',
            'Which staff members were mentioned most positively by guests this month, and what exactly did guests praise them for?',
            'Any local events or news that could affect demand?',
        ],
        tools:{
            query_metrics:'Querying metrics',
            list_reviews:'Fetching reviews',
            render_chart:'Generating chart',
            load_skill:'Loading analysis method',
        },
    },
    DateTimePickerHome:{
        label1:'Last Week',
        label2:'Last Month',
        label3:'Last 3 Months',
        label4:'This Year',
        Last_7_days:'Last 7 days',
        Last_Month:'Last Month',
        Current_Month:'Current Month',
        Current_Quarter:'Current Quarter',
        Current_Year:'Current Year',
        Custom:'Custom',
        allFrequencyOpts:[
            { value: "DAY", displayLabel: "Day" },
            { value: "WEEK", displayLabel: "Week" },
            { value: "MONTH", displayLabel: "Month" },
        ]
    },
    HotelIndex:{
        title:'Hotel Dashboard',
        FilterSheet:{
            OtaPlatform:'OTA Platform',
            DateRange:'Date range',
            DateFrequency:'Date & frequency',
            DateToolbar:'Date & toolbar',
            Apply:'Apply',
            More:'More',
        },
        PackageBanner:{
            regionLabel:'Subscription notice',
            viewPlans:'View plans',
            contactSales:'Contact sales',
            trialEnded:'Your free trial ended on {date}',
            trialEndsOn:'Your free trial ends on {date}',
            daysRemaining:'{days} days remaining',
            readOnlyPurgeNoDays:'Read-only access until data purge',
        },
        Platform_Overview:{
            title:'1. Platform Overview',
            tooltip:'This section will be updated weekly',
            tooltip1:'The response rate and average response time are sample data. After enabling integration, the system will display your hotel\'s real data.',
            text2:"Response rate:",
            Reviews:"Reviews",
            Reviews1:"Reviews:",
            ReviewCount:"Review | Reviews",
            text3:"Avg. response time",
            text4:"days",
            notAvailable:"Not available",
            unknown:"Unknown",
            noResponsesYet:"No responses yet",
            lessThanOneDay:"<1 day",
            text5:"Guests:",
            text6:"Total engagements",
            title1:"Morning Briefing",
            text7:'Data loading failed. Please try reloading later',
            otherPlatforms:'Other platforms',
            moveToExpanded:'Move to expanded',
            replaceWith:'Replace with',
            moreCount:'+{count} more',
            showAll:'Show all',
            compactView:'Compact view',
            manageSources:'Manage Sources',
            searchSourcesPlaceholder:'Search sources...',
            featuredSection:'Featured ({count})',
            otherSourcesSection:'Other sources ({count})',
            moveToFeatured:'Move to Featured',
            cancel:'Cancel',
            save:'Save',
            noSearchResults:'No sources match "{query}"',
            ReviewBySources:{
                'Direct booking':'Direct booking',
                DirectBookingSurvey:'Direct booking (survey)',
                DirectbookingText:'Data shown here is indicative only. Exact numbers and benchmarks will be visible once your integration is active',
                'Information Platforms':'Information Platforms',
                OTAs:'OTAs',
                'Social Media':'Social Media',
                Directbooking:'Direct booking',
                InformationPlatforms:'Information Platforms',
                SocialMedia:'Social Media',
            },
            ScoreImprovement:{
                current:'Current',
                target:'Target',
                title:'Score Improvement Simulator',
                subtitle:'Drag the slider to set your target score',
                reviewsNeeded:'top-score reviews needed to reach',
                projectionDisclaimer:'Projection based on past review patterns. Actual results may vary.',
                maxScoreReached:'Maximum score reached',
                alreadyAbove:'Already at or above target',
                noData:'No score data available',
                predicted:'predicted',
                assuming:'Assuming new reviews score',
                targetLabel:'Target Score',
                analyzing:'Analyzing',
                estimatedAt:'Estimated at',
                month:'month',
                months:'months',
                estimatedTooltip:'Based on the past 3-month average; improved volume or 5-star rate may accelerate the timeline.',
                // ── Steady-state model (recent average) ──
                ceilingLabel:'Recent avg.',
                ceilingTooltip:'A platform score is a running average, so the average of your recent reviews is where it settles — and is also what a healthy or under-pressure verdict is judged against. At the current review quality the score stops here — passing this line takes better reviews, not more of them.',
                beyondCeilingHint:'Target is past the reachable limit',
                week:'week',
                weeks:'weeks',
                year:'year',
                moreThanDuration:'more than {duration}',
                // ── Four-scenario model: health badge / theoretical bar / realistic timeline ──
                badgeHealthy:'Healthy',
                badgeAtRisk:'Under pressure',
                badgeUnknown:'Insufficient data',
                maintainHealthy:'{score} is holding steady',
                maintainAtRisk:'{score} may fall to {ceiling}',
                maintainAtRiskNoCeiling:'{score} may be hard to hold',
                maintainUnknown:'Score stability cannot yet be assessed',
                stabilityLabel:'Score stability',
                cannotAssessYet:'Cannot be assessed yet',
                barToTarget:'To reach {target}: about {count} perfect-score review | To reach {target}: about {count} perfect-score reviews',
                barNearMax:'Already close to the maximum',
                barUnavailable:'Review estimate unavailable',
                timeExpected:'Around {duration}',
                timeMoreThan:'More than {duration}',
                timeNoData:'Time estimate unavailable',
                timeUnreachableAtAverage:'Not reachable at the current average',
                requiredAvgNote:'Future reviews must average above {required}',
            },
        },
        Performance_Analytics:{
            title:"2. Performance Analytics",
            tooltip1:'This section will be updated daily',
            title1:"Overall Performance",
            text1:'Customize KPI',
            label1:"Top 5 strengths",
            label2:"Top 5 areas for improvement",
            label3:"Top Markets",
            label4:"Traveller Type",
            card1:"Room Comfort",
            card2:"Cleanliness",
            tooltip2:'Please select a different time range or frequency',
            tooltip3:'No improvement areas data available',
            text2_1:'Goals',
            text2:'Performance',
            categoryGoalsTitle:"Category Goals vs Performance",
            categoryGapTitle:"Category Gap Table",
            Score_details:"Score details",
            Comparison_options:"Comparison options：",
            YoY:"YoY",
            MoM:"MoM",
            WoW:"WoW",
            QoQ:"QoQ",
            'current_period':'current period',
            'previous_period':'previous period',
            'the_same_period_last_year':'the same period last year',
            cirpieTooltip:'Define extra KPIs like golf, tennis, weddings, or meetings to track property-specific performance',
            Specific_classification:"Specific classification",
            No_of_reviews:"Reviews",
            impact:"Impact",
            No_of_reviews_tooltip:"Insufficient reviews affect the system's rating",
            Insufficient_reviews:"Insufficient reviews",
            No_reviews:"No reviews",
            WTK_score_8:"WQI ≥ 8",
            WTK_score_6:"5 ≤ WQI < 8",
            WTK_score_4:"WQI < 5",
            eye_tooltip:{
                Positive:'Positive',
                Neutral:'Neutral',
                Negative:'Negative',
                PositiveQTY:'Positive',
                NeutralQTY:'Neutral',
                NegativeQTY:'Negative',
                quantity:' quantity',
                Reviews_ratio:'Ratio',
                ReviewsBySubcategory:'Reviews by subcategory',
                sort:'Sort by',
                score:'Score',
                review:'Review',
            },
            country_tooltip:'Please note that not all data sources provide guest origin information, so the data presented here may have limitations.',
        },
        Current_Situation:{
            title:"Period Overview",
            Select_report_type:'Select report type',
            Low_Data:'Low Confidence',
            Low_Data_Tooltip:'Small sample size — insights are directional only and may not reflect overall guest sentiment.',
            Medium_Data:'Medium Confidence',
            Medium_Data_Tooltip:'Moderate sample size — results indicate emerging trends but should be interpreted with context.',
            High_Data:'High Confidence',
            High_Data_Tooltip:'Large sample size — results are statistically robust and highly representative of guest sentiment.',
            Total_reviews:'Total Reviews',
            Week:'Week',
            Month:'Month',
            HalfMonth:'Half-Month',
            Quarter:'Quarter',
            HalfYear:'Half-Year',
            Year:'Year',
            Last_period:'Last period',
            Next_period:'Next period',
            Comment_Ratio:"Ratio",
            Highlight:"Key Highlights",
            Issue:"Key Issues",
            Trend_overview:"Trend Overview",
            Total_Score_Overview:"Total Score",
            AI_Score_Tooltip:"Based on Where to Know AI semantic analysis of all reviews, not simply OTA platform scores.",
            Historical_data:"Historical",
            Current_month_data:"Current month",
            Top_Lists:"Top Lists",
            Strengths : "Positive: WQI > 8",
            Areas_for_improvement : "Negative: WQI < 7",
            Top_5_Positive:'Top 5 Positive',
            Top_5_Negative:'Top 5 Negative',
            frequency:"Frequency",
            Category_Summary:"Category Summary",
            Category_Insights:"Category Insights",
            category_tab_short:{
                Location:"Location",
                Cleanness:"Cleanliness",
                Room:"Room",
                Amenities:"Hotel Amenities",
                F_and_B:"F & B",
                Service:"Service",
                Value:"Value",
                Food_Quality:"Food",
                Beverage_Quality:"Beverage",
                Service_Quality:"Service",
                Ambience:"Ambience",
                Cleanliness:"Cleanliness",
                Value_For_Money:"Value",
            },
            Expand_All:"Expand all",
            Collapse_All:"Collapse all",
            Positive_insight:"Positive insight",
            Negative_insight:"Negative insight",
            Positive_insights:"Positive insights",
            Negative_insights:"Negative insights",
            Recommended_Action:"Recommended Action",
            Tips_for:"Tips for",
            noIssuesReported:"No issues reported",
            provenance_view_one:'Based on {n} review',
            provenance_view_other:'Based on {n} reviews',
            provenance_title:'Review evidence',
            provenance_supporting:'Supporting reviews',
            // 类别行显示的是该类别的评论总数，抽屉里只列支撑这一条洞察的那几条 ——
            // 两个数字不一样是对的，但不说明白就像是哪边算错了。
            provenance_subset: '{shown} of {total} reviews in {subject} back this point',
            provenance_partial:'Showing {shown} of {total}: some of these reviews are no longer accessible.',
            provenance_forbidden:"You don't have access to these reviews.",
            provenance_none:'None of these reviews are accessible any more.',
            provenance_failed:'Could not load the reviews. Please try again.',
            Management_Focus:"Management Focus",
            From_Insights_to_Action:'From insights to action',
            From_Insights_to_Action1:'Management focus for the period',
            Solution :"Management Action",
            Solution_Sub :"Operational priorities for the next period",
            Overall_Solution :"Overall Solution",
            Maintain :"Maintain",
            Resolve :"Resolve",
            Category_Solution :"Category Solution",
            Category_Solution_Text :"Insufficient data this period. Maintain current monitoring",
            insufficient_data:"insufficient data",
            Next_refresh:'Next refresh',
            Medium_3_5_mentions:'Medium data volume (3-5 mentions), insights may be limited',
            Low_3_mentions:"Low data volume (<3 mentions), insights are limited",
            limitedData:'Limited data, may not be representative',
            period_Insufficient:'Insufficient data this period. Maintain current monitoring',
            period_Insufficient1:'The following categories currently have limited data for this period. Please continue monitoring',
            Top_5_Positives:'Top Positives',
            Top_5_Positives_text1:'No top positives for this period',
            Top_5_Positives_text2:'There aren’t enough consistently positive mentions to form a ranking',
            Top_5_Negatives:'Top Negatives',
            Top_5_Negatives_text1:'No top negatives for this period',
            Top_5_Negatives_text2:'There aren’t enough consistently negative mentions to form a ranking',
            Friendly_staff:'Friendly staff',
            Trend:'Trend',
            Comment:'Comment',
            Trend_Insight:'Insight',
            Performance_Trend:'Performance Trend',
            Expand_All:'Expand all',
            Collapse_All:'Collapse all',
            totalReviews_one:"{n} review",
            totalReviews_other:"{n} reviews",
            Total_reviewsTooltip:"This figure reflects the total number of reviews, including those containing only ratings. Consequently, the number of reviews analysed by WTK AI may be lower than this figure, resulting in a natural variance from the total review count.",
            reviewsTextAnalysed_one:"{n} review with text analysed",
            reviewsTextAnalysed_other:"{n} reviews with text analysed",
            reviewsTextAnalysedTooltip:"Reviews with written text that WTK AI has analysed. Ratings-only reviews have no text to analyse, so this number can be lower than Total Reviews.",
            reviewsMentionCategory_one:"{n} review analysed",
            reviewsMentionCategory_other:"{n} reviews analysed",
            reviewsMentionCategoryTooltip:"Analysed reviews that mention this category. One review can mention several categories, so these numbers don't add up to the analysed total.",

            Market_View_Competitive_Summary:'Market View & Competitive Summary',
            Market:'Market',
            Competitive_Dimensions:'Competitive Dimensions',
            Execution_Signature:'Execution Signature',
            Experience_Boosters_By_Competitors:'Experience Boosters By Competitors',
            Guest_Desire:'Guest Desire',
            Execution:'Execution',
            Takeaway:'Takeaway',
            Operational_Challenges:'Operational Challenges',
            Share_Trigger_Landscape:'Share Trigger Landscape',
            Action_Focus:'Action Focus',
            Overall_Direction:'Overall Direction',
            Category_Solutions:'Category Solutions',
            Defensive_Offensive_Moves:'Defensive & Offensive Moves',
            Defensive_Moves:'Defensive Moves',
            Offensive_Moves:'Offensive Moves',
            Competitor_Patterns:'Competitor Patterns',
            Strategic_Playbook:'Strategic Playbook',
            Portfolio:{
                Tabs_Restaurant:'Restaurant',
                Tabs_Portfolio:'Portfolio',
                Critical_Items:'Critical Items',
                Competitor_Alerts:'Competitor Alerts',
                Cross_Outlet_Comparison:'Cross Outlet Comparison',
                Category:'Category',
                Signal:'Signal',
                Standout_Positive:'Standout Positive',
                Standout_Negative:'Standout Negative',
                Portfolio_Wide_Issue_Label:'Portfolio-wide issue:',
                Outlet_Digest:'Outlet Digest',
                Strength_Label:'Strength:',
                Concern_Label:'Concern:',
                Watch_Label:'Watch:',
                Portfolio_Actions:'Portfolio Actions',
                Review_Generation_Recommendations:'Review Generation Recommendations',
                Status_Requires_Immediate_Attention:'Requires Immediate Attention',
                Status_Monitor_Closely:'Monitor Closely',
                Status_No_Action_Required:'No Action Required',
                Status_Insufficient_Data:'Insufficient Data',
                Signal_Strong:'strong',
                Signal_Mixed:'mixed',
                Signal_Weak:'weak',
                Signal_Insufficient_Data:'insufficient data',
                Unknown_Outlet:'Unknown Outlet',
                Staff_Positive_Outlet_Ranking:'Top 10 staff by positive mentions',
                Ranking_Staff_Name:'Staff',
                Ranking_Outlet_Name:'Outlet',
                Staff_Positive_Total:'Positive',
                Staff_Negative_Total:'Negative',
                Staff_Mentions_Total:'Total mentions',
                Staff_Positive_Ranking_Empty:'No outlet dynamics data for this period.',
            },
        },
        Staff_Mentions_Leaderboard:{
            View_By_Name:'By Name',
            View_By_Division:'By Division',
            Sentiment_All:'Show All',
            title:'Staff Mentions Leaderboard',
            empty_title:'No staff were mentioned in this period',
            empty_hint:'Try a longer date range, such as Last Month or Current Quarter.',
            Updated:'Updated',
            Rank:'Rank',
            Name:'Name',
            Last_mention:'Last mention',
            Total_mentions:'Total',
            MoM:'MoM',
            Positive:'Positive',
            Negative:'Negative',
            Positive_Ratio:'Positive Ratio',
            Review_date:'Review date',
            Show_More:'Show More',
            Show_All:'Show All',
            Show_Less:'Show Less',
            MTD:'MTD',
            Finalized:'Finalized',
            Export_CSV:'Export CSV',
            Export_Type:'Type',
            Export_Source:'Source',
            Export_Reviewer:'Reviewer',
            Export_Mention_Sentiment:'Mention sentiment',
            Export_Evidence:'Evidence',
            Export_Review:'Review',
            Export_Review_Link:'Review link',
            popoverTitle:'Note:',
            popoverText:"This score is the WQI, using a scale of 1-10, which may differ from the guest source's original score.",
        },
        LastWeekTopLists:{
            title:"Last week's top lists",
            Type:"Type",
            Positive:"Positive",
            Negative:"Negative",
            emptyState:"No data available. There may not be enough reviews from last week.",
            notEnoughWritten:"Not enough written reviews last week to build the lists. Rating-only reviews have no text to analyze.",
            generating:"Last week's lists are being prepared. Check back soon.",
        },
        Activity24h:{
            title:"Recent Activity",
            past24h:"Live",
            review:"review",
            reviews:"reviews",
            analysed:"analysed",
            reviewDetails:"Review Details",
            positiveReviews:"Positive Reviews",
            negativeReviews:"Negative Reviews",
            positive:"Positive",
            negative:"Negative",
            positiveLower:"positive",
            negativeLower:"negative",
            withContent:"with content",
            ratingOnly:"rating-only",
            sentiment:"Sentiment",
            contentLabel:"Content",
            riskSignals:"Risk Signals",
            noReviews:"No new reviews in the last 72 hours.",
            monitoring:"Monitoring continues.",
            viewMore:"View more",
            viewLess:"View less",
            noMatchingReviews:"No matching reviews found.",
            emptyPositive:"No positive review signals detected in recent activity.",
            emptyNegative:"No negative review signals detected in recent activity.",
            wtkScoreLabel:"WQI",
            syncHint:"New reviews are analyzed and surfaced here as they arrive. Depending on platform sync timing, a slight delay may occur.",
            riskSignalLabels:{
                extremely_low:"Score Alert",
                negative_only:"Negative only",
                rating_discrepancy:"Score mismatch",
            },
            riskSignalTooltips:{
                extremely_low:"Reviews that scored at or below your custom alert threshold. You can configure this threshold in Settings to monitor reviews that need attention.",
                negative_only:"Negative Only indicates that the review contains only negative feedback and no positive mentions, regardless of the overall score.",
                rating_discrepancy:"Score mismatch indicates that the guest's rating and the AI analysis result show a significant difference in sentiment. This may happen when the score is relatively high but the written feedback is mostly negative, or vice versa.",
            },
            reviewSummary:"Summary",
            guestRating:"Guest Rating",
            guestReview:"Guest Review",
            openOriginalReview:"Open original review",
            relatedReview:"related reviews",
            nightUnit:"night | nights",
        },
        RoomTypeBreakdown:{
            rtbTitle:"Room Type",
            positive:"Positive",
            negative:"Negative",
            total:"Total",
            showing:"Showing {visible} of {total}",
            popover:"Room type could be identified in {identified} of {total} reviews ({coverage}%). Most Google and TripAdvisor reviews do not include room type information.",
            filterAll:"All",
            empty:"No room-related evidence found for this period.",
            positiveMentions:"Positive Mentions",
            negativeMentions:"Negative Mentions",
            relatedReview:"related reviews",
            expandMore:"+{count} more",
            collapse:"Show less",
        },
    },
    RestaurantDashboard:{
        title:'Restaurant Dashboard',
        Platform_Overview:{
            title:'1. Platform Overview',
            tooltip1:'The response rate and average response time are sample data. After enabling integration, the system will display your restaurant\'s real data.',
        },
        Performance_Analytics:{
            title:'2. Performance Analytics',
        },
        Selected_Restaurant:'Selected Restaurant',
        Performance_Highlights:'Performance Highlights',
        Overall_Performance:'Overall Performance',
        Food_Quality:'Food Quality',
        Beverage_Quality:'Beverage Quality',
        Service_Quality:'Service Quality',
        Ambience:'Ambience',
        Cleanliness:'Cleanliness',
        Value_Perception:'Value For Money',
        Sarai:'Sarai',
        Istros:'Istros',
        Review_sources:'Review sources',
        botList:{
            Top_5_Positive_Mentions:'Top 5 Positive Mentions',
            Top_5_Negative_Mentions:"Top 5 Negative Mentions",
        },
        Food_Beverage_Mentions_Leaderboard:'Food & Beverage Mentions Leaderboard',
        Food:"Food",
        Beverage:"Beverage",
        Show_all:"Show All",
        LastMonthTopLists:{
            title:"Last month's top lists",
            Type:"Type",
            Positive:"Positive",
            Negative:"Negative",
            emptyState:"No data available. There may not be enough reviews from last month.",
            notEnoughWritten:"Not enough written reviews last month to build the lists. Rating-only reviews have no text to analyze.",
            generating:"Last month's lists are being prepared. Check back soon.",
        },
    },
    ReviewsTitle:{
        // WTK-727: publish a reply on Google
        PostToGoogle: "Post to Google",
        PostToGoogleConfirm: "This reply will be published on Google as your business's public response to this review. Post it now?",
        PostToGoogleConfirmButton: "Post",
        PostToGoogleCancel: "Cancel",
        PostedToGoogle: "Reply posted on Google",
        PostToGoogleFailed: "Could not post the reply on Google",
        // WTK-730: preview before posting, edit a reply on Google
        EditOnGoogle: "Edit on Google",
        UpdateOnGoogleConfirm: "This replaces your current reply on Google with the text below. Save it now?",
        SaveToGoogle: "Save to Google",
        UpdatedOnGoogle: "Reply updated on Google",
        // WTK-820: who replied from WhereToKnow
        ReplyLogPosted: "{name} posted this reply on Google from WhereToKnow · {time}",
        ReplyLogEdited: "{name} edited the reply on Google from WhereToKnow · {time}",
        ReplyLogFailed: "{name} tried to post on Google, but it failed · {time}",
        ReplyLogShow: "History ({n})",
        ReplyLogHide: "Hide history",
        ReplyLogSomeone: "A colleague",
        // WTK-743: reply on Tripadvisor through its Management Center
        ReplyOnTripadvisor: "Reply on Tripadvisor",
        TripadvisorReplyCopied: "Reply copied. Paste it on the Tripadvisor page that opened and submit it there, signed in as the listing's manager. Tripadvisor checks responses before publishing them.",
        TripadvisorReplyCopyFailed: "Tripadvisor opened, but the reply could not be copied. Copy it from here.",
        title:'Reviews & Reply',
        avgResponseTime:"avg.response time",
        Unreplied:"Unreplied:",
        Flagged:"Flagged:",
        ScoreColorGuide:'Score Color Guide',
        Business_Traveller:'Business Traveller',
        placeholder1:"Select language",
        Translation:"Translation",
        Translating:"Translating",
        Original:"Original",
        GuestUser:"Guest User",
        Stay:"Stay:",
        Review:"Review:",
        GoToTheReview:"Go to the review",
        Search_Match_Count:"{count} matching reviews",
        Search_Match_Summary:"{mentions} across {reviews}",
        Search_Mentions_Count:"{n} mention | {n} mentions",
        Search_Reviews_Count:"{n} review | {n} reviews",
        Search_Sort_Mentions:"Mentions",
        Search_Sort_Mention_Asc:"Mentions: low to high",
        Search_Sort_Mention_Desc:"Mentions: high to low",
        Search_Sort_Default:"Default sort",
        Review_Keyword_Mentioned:"Mentioned {count} times in this review",
        ReadMore:"Read More",
        ShowLess:"Show Less",
        text4:"Type Proportion",
        text5:"AI Reply",
        text51:"Reply",
        text6:"Generate",
        text7:"Edit",
        text8:"Send",
        Reply:'Reply',
        Copy:'Copy',
        Replied:'Replied',
        Forward:'Forward',
        ForwardTo:'Forward to',
        ForwardCancel:'Cancel',
        ForwardSend:'Send',
        ForwardNoStaff:'No staff yet',
        ForwardNoPermission:'You don\'t have access to the staff list. Ask an admin of this property.',
        ForwardUseWtk:'Use WTK to send',
        ForwardNotePlaceholder:"Say why you're forwarding this review to your colleague… (optional)",
        ForwardSendViaWtk:'Send via WTK',
        ForwardSending:'Sending…',
        ForwardSent:'Sent via WTK',
        Ratings_only:'Ratings only',
        Ratings_only_tooltip:'This guest left a star rating but no written comment, so there is no text for AI to analyse.',
        filters:{
            title:'Filters',
            Review_Mode:'Review Mode',
            Review_Mode1:'Guest Score',
            Score_Scale_Note:'10-point scale. Scores from 5-star platforms are doubled (5★ = 10).',
            Review_Mode2:'AI Insights',
            Review_ModeNote:'Info note',
            Review_ModeNote1:'Only show the comments with text content(comments without text have been hidden)',
            Review_Type:'Review Type',
            Review_Type1:'All reviews',
            Review_Type2:'With text',
            Review_Type3:'Ratings only',
            Review_Type1_disabled:'Not available when "Text only" mode is active.',
            Sentiment_Status:'Sentiment Status',
            Source_Language:'Review language',
            Source_Language_Placeholder:'All languages',
            Summary_Type:'Summary type',
            Summary_TypeObj:{
                IncludePositive:'Include positive',
                IncludeNegative:'Include negative',
                PositiveOnly:'Positive only',
                NegativeOnly:'Negative only',
            },
            Review_Status:'Review Status',
            Review_StatusLabels:[
                {
                    label:'Positive',
                    value:'Positive',
                },
                {
                    label:'Negative',
                    value:'Negative',
                },
                {
                    label:'Score mismatch',
                    value:'RatingDiscrepancy',
                },
            ],
            Categories:'Categories',
            Sort:'Sort',
            Sort_By:'Sort By',
            Sort_Time:'Time',
            Sort_Score:'Score',
            Sort_Weight:'Weight',
            Sort_Time_Newest:'Newest first',
            Sort_Time_Oldest:'Oldest first',
            Sort_Score_High:'High to low',
            Sort_Score_Low:'Low to high',
            Sort_Weight_Highest:'Highest first',
            sortObj:{
                'Time (newest first)':'Time（newest first）',
                'Time (oldest first)':'Time（oldest first）',
                'Score (high to low)':'Score（high to low）',
                'Score (low to high)':'Score（low to high）',
                'Weight (highest first)':'Weight（highest first）',
            },
            Reply_Status:'Reply Status',
            Reply_StatusObj:{
                'Replied':'Replied',
                'Pending':'Not replied',
            },
            Apply:'Apply',
            Cancel:'Cancel',
            Reset:'Reset',
            Status:'Status',
            Status_Labels:[
                {
                    label:'Saved reply',
                    value:'SavedReply',
                },
                {
                    label:'With notes',
                    value:'WithNotes',
                },
            ],
            Meal_Time:'Meal Time',
            mealTime:{
                Lunch:'Lunch',
                Dinner:'Dinner',
                Brunch:'Brunch',
                LUNCH:'Lunch',
                DINNER:'Dinner',
                BRUNCH:'Brunch',
                BREAKFAST:'Breakfast',
                OTHER:'Other',
            },
            Dining_Mode:'Dining Mode',
            diningMode:{
                DineIn:'Dine in',
                TakeOut:'Take out',
                DINE_IN:'Dine in',
                TAKE_OUT:'Take out',
            },
            Experience_Attributes:'Experience Attributes',
            experienceAttr:{
                NoiseLevel:'Noise Level',
                Quiet:'Quiet',
                Moderate:'Moderate',
                Loud:'Loud',
                QUIET:'Very quiet',
                MODERATE:'Moderate noise',
                LOUD:'Loud, but you can still talk',
                NOT_SURE:'Not sure',
                GroupSize:'Group Size',
                Solo:'Solo',
                Couple:'Couple',
                SmallGroup:'Small Group',
                LargeGroup:'Large Group',
                SOLO:'1 person',
                COUPLE:'2 people',
                SMALL_GROUP:'3-4 people',
                LARGE_GROUP:'5-8 people',
                ALL:'Suitable for all group sizes',
                SeatingType:'Seating Type',
                Indoor:'Indoor',
                Outdoor:'Outdoor',
                Bar:'Bar',
                INDOOR:'Indoor dining area',
                OUTDOOR:'Outdoor patio / terrace',
                BAR:'Bar area',
                BOOTH:'Booth seating',
                COUNTER:'Counter seating',
                PRIVATE:'Private dining room',
            },
        },
        Guest_Tags:'Guest Tags',
        contextKeys:{
            'Noise level':'Noise Level',
            'Group size':'Group Size',
            'Seating':'Seating Type',
            'Dinner size':'Group Size',
            'Meal type':'Meal Time',
            'Order type':'Dining Mode',
            'Price per person':'Price Per Person',
            'Parking space':'Parking Space',
            'Parking options':'Parking Options',
            'Kid-friendliness':'Kid-Friendliness',
            'Vegetarian options':'Vegetarian Options',
            'Wheelchair accessibility':'Wheelchair Accessibility',
            'Wi-Fi':'Wi-Fi',
            'Outdoor seating':'Outdoor Seating',
            'Live music':'Live Music',
            'Private dining':'Private Dining',
            'Reservation':'Reservation',
            'Wait time':'Wait Time',
            'Service options':'Service Options',
            'Highlights':'Highlights',
            'Atmosphere':'Atmosphere',
            'Popular for':'Popular For',
            'Accessibility':'Accessibility',
            'Amenities':'Amenities',
            'Crowd':'Crowd',
            'Planning':'Planning',
            'Payments':'Payments',
            'Dining options':'Dining Options',
            'Offerings':'Offerings',
            'Children':'Children',
            'Seating type':'Seating Type',
            'Noise Level':'Noise Level',
            'Group Size':'Group Size',
        },
        contextValues:{
            'Yes':'Yes',
            'No':'No',
            'Plenty of parking':'Plenty of parking',
            'Free parking lot':'Free parking lot',
            'Paid parking lot':'Paid parking lot',
            'Street parking':'Street parking',
            'No parking':'No parking',
        },
        noReviews1:'There are no reviews for the selected period/source, please reset the',
        noReviews2:'filter and try again',
        WTKscore:'WQI:',
        WTKscore1:'calculated based on advanced AI sentiment analysis and contributions from hotel experts, with a scale of 1–10. For sources originally using a 1–5 scale (such as Google), scores have been converted into a 1–10 scale to ensure fair comparability across all platforms',
        Note:"Note",
        NoteText:"This review has no written feedback. The reply is generated solely based on the score and may therefore be more generic.",
        NoteText1:"This review is currently being analyzed. Once the analysis is complete, the reply interface will become available.",
        Summary:'Summary',
        LoadTheCommentData:'Load the comment data',
        CategoryWeight:'Category Weight',
        CopyAllSections:'Copy all sections',
        showTranslatedContent:"No translation data for the current reply. Click to translate later",
        showOriginalContent:'Current reply has no "Original" data. Click to translate',
        Pending_analysis:'Pending analysis',
        Pending_analysis_tooltip:'This review is currently being analysed against the hotel category benchmark, with results to be displayed shortly',
        Pending_analysis_tooltip1:'This review is beyond the time frame of the current subscription plan, please contact us should you require expanding the analysis scope',
        Reply_pending_tooltip:'Reply becomes available once this review has been analysed',
        Rating_discrepancy:'Score mismatch',
        Rating_discrepancy_tooltip:'This reviews deviates from the semantic analysis and user ratings, and requires additional attention from the management team.',
        // 评论 AI 分析为空、分数改用平台评分时，分数旁的标签和悬停文字（WTK-792）
        Platform_rating:'Platform rating',
        Platform_rating_tooltip:'AI analysis not available yet. Showing the platform rating.',
        Rating_mismatch_single:'{dimensions} rating mismatch',
        Rating_mismatch_multi:'{dimensions} mismatch',
        Discrepancy_dimension:{
            Service:'Service',
            Food:'Food',
            Atmosphere:'Atmosphere',
            Beverage:'Beverage',
            Cleanliness:'Cleanliness',
            Value:'Value',
        },
        Unknown:'Unknown',
        Switch_to_list_mode:'Switch to list mode',
        Switch_to_preview_mode:'Switch to preview mode',
        Export_Excel:'Export Excel',
        // WTK-573 筛选栏图标说明 / 重置按钮
        Filters_Tip:'Filters',
        Filters_Active_Tip:'Filters (some applied)',
        Search_Tip:'Search',
        Reset_Filters:'Reset',
        Keyword_Search_Placeholder:'Search review text…',
        Filter_Sheet_Period:'Period',
        Filter_Sheet_Keyword:'Keyword',
        Expand:'Expand',
        Collapse:'Collapse',
        Has_internal_note:'Has internal note',
        This_reviews_has_been_saved:'This reviews has been saved',
        Note_deleted:'Note deleted',
    },
    Replies:{
        title:'Reply Setting',
        Hotel_Name_Usage:{
            title:'Hotel Name Usage',
            title1:'Hotel name',
            input1:'Input hotel name',
        },
        Restaurant_Name_Usage:{
            title:'Restaurant Name Usage',
            title1:'Restaurant name',
            input1:'Input restaurant name',
        },
        Tone:{
            title:'Tone',
            label1:'Brand preset',
            label2:'Formality',
            label3:'Contractions',
            label4:'Emoji',
            label5:'Humour',
            label6:'Exclamation limit',
            label7:'Use hotel name',
            label7_restaurant:'Use restaurant name',
            option1:[
                {
                    label:'Formal elegant',
                    value:'formal_elegant',
                },
                {
                    label:'Premium warm',
                    value:'premium_warm',
                },
                {
                    label:'Casual playful',
                    value:'casual_playful',
                },
                {
                    label:'Minimal neutral',
                    value:'minimal_neutral',
                },
            ],
            option2:[
                {
                    label:'Medium',
                    value:'medium'
                },
                {
                    label:'High',
                    value:'high'
                },
            ],
            option3:[
                {
                    label:'Low',
                    value:'low'
                },
                {
                    label:'Medium',
                    value:'medium'
                },
            ],
            showData1:[
                'Low: “Thanks for your feedback! We’re glad you enjoyed your stay”',
                'Medium: “Thank you for your feedback. We are pleased to know you enjoyed your stay with us”',
                'High: “We sincerely thank you for your valuable feedback and are delighted that your stay was enjoyable”'
            ],
            showData2:'I am, I\'m',
            showData3:'Controlling the intensity of one\'s sense of humor',
            showData4:'The maximum number of exclamation marks allowed',
            showData5:'Include the hotel name in replies (on) or not (off)',
            showData5_restaurant:'Include the restaurant name in replies (on) or not (off)',
        },
        LanguageRules:{
            title:'Language Rules',
            label1:'Language preference',
            label2:'Pronoun style',
            radio1:[
                {
                    text1:'Auto',
                    text2:'（Automatically follow the language of the guest\'s comments）',
                    value:'auto'
                },
                {
                    text1:'Fixed',
                    text2:'（Always reply in the specified language）',
                    value:'fixed'
                },
            ],
            option1:[
                {
                    label:'Formal',
                    value:'formal'
                },
                {
                    label:'Informal',
                    value:'informal'
                },
            ],
            alertTitle:'Note',
            alertData:'If you select “Mandatory designation,” replies will always be generated in the chosen language, even if the guest wrote their review in another language. This may appear inconsistent',
            showData1:'Only available in languages with formal/informal pronouns (German, French, Italian, Chinese)',
        },
        WordPreferences:{
            title:'Word Preferences',
            label1:'Preferred words',
            label2:'Avoid words',
            tagInput1:['Team','Experience'],
            tagInput2:['Patronage','Herewith'],
        },
        Title:{
            title:'Title',
            label1:'Greeting style',
            label2:'Default greeting',
            option1:[
                {
                    label:'Hi [Username]',
                    value:'Hi [Username]',
                },
                {
                    label:'Hello [Username]',
                    value:'Hello [Username]',
                },
                {
                    label:'Dear [Username]',
                    value:'Dear [Username]',
                },
                // {
                //     label:'Custom',
                //     value:'Custom',
                // },
            ],
            option2:[
                {
                    label:'Dear Guest',
                    value:'Dear Guest',
                },
                {
                    label:'Hello Traveler',
                    value:'Hello Traveler',
                },
                // {
                //     label:'Custom',
                //     value:'Custom',
                // },
            ],
        },
        MainBody:{
            title:'Main Body',
            title1:'Smart Replies',
            label1:'Text',
            label2:'Category',
            label3:'Topic',
            label4:'Trigger keywords',
            label5:'Actions',
            button1:'Add Smart Reply',
            emptyText:'+ Add your first Smart Reply',
            showData1:'Smart Replies are triggered automatically based on keywords and semantic matching, and each one appears only once',
            placeholder3:"Create new topic",
            placeholder4:"Search or add options",
            placeholder5:"+add",
            delTitle:'Delete Confirmation',
            delTitleTooltip:'The data will be irrecoverable after deletion. Please proceed with caution.',
            cancelBtn:'Cancel',
            delBtn:'Delete',
            SaveTitle:'Save modifications',
            SaveTitleTooltip:'The modified content has not been saved. Do you want to save it?',
            Do_not_save:'Do not save',
            Do_not_save1:'Discard changes',
            Save:'Save',
        },
        Ending:{
            title:'Ending',
            label1:'Invite back policy',
            label2:'Signature',
            radio1:[
                {
                    text1:'Always invite back',
                    text2:'Every reply includes an invitation to return',
                    value:"always_invite_back"
                },
                {
                    text1:'Invite on positive or mixed feedback',
                    text2:'Only invite when the guest\'s comment is positive or neutral',
                    value:"invite_on_positive_or_mixed_feedback"
                },
                {
                    text1:'Smart invite (AI decides)',
                    text2:'AI will decide; no invitation in clearly negative cases',
                    value:"smart_invite"
                },
            ],
            placeholder1:"Add your team or manager name here",
            placeholder2:'The Guest Relations Team", "Your London Hotel',
        },
        ReplyLength:{
            title:'Reply Length',
            radio1:[
                {
                    text1:'Short (30-60 words)',
                    text2:' (Quick and simple: suitable for OTA platforms)',
                    value:"short",
                },
                {
                    text1:'Standard (60-100 words)',
                    text2:' (Balanced and professional: recommended default)',
                    value:"standard",
                },
                {
                    text1:'Detailed (100-140 words)',
                    text2:' (More comprehensive and narrative; ideal for official websites or email replies)',
                    value:"detailed",
                    showTooltip: true
                },
                {
                    text1:'Dynamic (AI adjusts automatically)',
                    text2:' (Flexible length; adapts to the guest\'s review)',
                    value:"dynamic",
                },
            ],
        },
        button1:'Preview',
        button2:'Save settings',
        Preview:{
            title:'Preview',
            label1:"Title",
            label2:"Start",
            label3:"Main Body",
            label4:"Ending",
            button1:'cancel',
            button2:'confirm',
        },
        notes:{
            Notes:'Notes',
            internal:'internal',
            No_internal_notes_yet:'No internal notes yet.',
            Add_note:'Add note',
            Only_visible_to_your_team:'Only visible to your team',
            placeholder:'Add analysis, handling notes, or follow-up actions for this comment…',
            Cancel:'Cancel',
            Save:'Save',
            Delete:'Delete',
            Edit:'Edit',
            Delete_Text:'The data will be irrecoverable after deletion. Please proceed with caution.',
            Delete_note:'Delete note',
        },
        Reply_Saved:'Reply Saved',
        Reply_Saved_text:'Your reply has been saved. You’ll find it in the Reply Library section.',
    },
    competitors:{
        title:'Competitors',
        title1:'Selected Hotels：',
        title1_restaurant:'Selected Restaurants：',
        title2:'Average score of OTA platforms',
        title3:'Hotel Overall',
        title31:'Hotel Standalone Score',
        title31_restaurant:'Restaurant Standalone Score',
        Relative_Performance:'Relative Performance',
        Relative_Performance_tooltip_title:'Note: ',
        Relative_Performance_tooltip:'The Relative Performance Index is calculated by dividing your stand-alone overall score by the competitors’ average score. A value below 1.0 means you are performing below the competitors’ average, while a value above 1.0 means you are performing above the competitors’ average.',
        Under_performance:'Under performance',
        Over_performance:'Over performance',
        label3_1:'Your hotel Overall',
        label3_1_restaurant:'Your restaurant Overall',
        title4:'Competitor',
        title5:'Overview of Scores',
        'score':'Total score',
        'Total_reviews':'Total Reviews',
        'location_neighbourhood':'Location & Neighbourhood',
        'cleanliness':'Cleanliness',
        'room_comfort':'Room Facilities & Comfort',
        'hotel_amenities_atmosphere':'Hotel Amenities &  Atmosphere',
        'food_beverage':'Food & Beverage',
        'guest_experience_service':'Guest Experience & Service',
        'value_for_money':'Value for Money',
        'food_quality':'Food Quality',
        'beverage_quality':'Beverage Quality',
        'service_quality':'Service Quality',
        'ambience':'Ambience',
        'value_perception':'Value For Money',
        'your_hotel':'Your Hotel',
        // 手机：OTA 平台平均得分（按平台切换的排名列表）
        ota_reviews:'{n} reviews',
        ota_vs_you_up:'{n} above you',
        ota_vs_you_down:'{n} below you',
        ota_vs_you_same:'Same as you',
        ota_no_score:'No score',
        ota_platforms:'Platforms',
        // 手机分析区筛选入口：「最近一月 · 6 家酒店」
        hotels_count:'{n} hotels',
        restaurants_count:'{n} restaurants',
        averageTooltip:'The average rating of competing hotels other than your hotel',
        diffTooltip:'The difference between your hotel score and the score of the competitors’ average',
        title6:'Category:',
        lowSampleTooltip:'Low sample (n={n}) — directional only, not statistically reliable',
        wow:{
          title:'Week-over-week Changes',
          tooltip:'Compare current period to previous same-length period. Hotels with sample < 10 show the change in muted style — interpret as directional only.',
          colHotel:'Hotel',
          colRestaurant:'Restaurant',
          lastWeek:'Last week',
          thisWeek:'This week',
          change:'Change',
          you:'You',
          lowSample:'Low sample (n={n}) — change directional only',
        },
        title61:'Category Performance',
        compareLabel:'Compare period',
        compareStartPlaceholder:'Start date',
        compareEndPlaceholder:'End date',
        compareVs:'vs',
        compareSamePeriodHint:'Please select a different period',
        viewPrevPeriodReviews:'View compare period reviews',
        compare:'Compare',
        bySentiment:'By Sentiment',
        byCategory:'By Category',
        topic:'Topic',
        review:'Review',
        byTopic:'By Topic',
        byNumber:'By Number',
        period:'Period',
        previousValueLabel:'Compare period',
        currentValueLabel:'Current',
        changeLabel:'Change',
        title7:'Summary',
        label7_1:'Highlight',
        label7_2:'Suggestion',
        label7_3:'Issue',
        title8:'Customer Journey',
        title9:'Review overview by sources',
        title9_1_1:'Review distribution',
        label9_1:'Social media',
        label9_2:'Preview Mode',
        title10:'Social media platform',
        label10_1:'Total engagements',
        title11:'Countries / Area',
        title12:'Traveller Type',
        My_Top_5_Markets:'My Top 5 Markets',
        My_Top_5_Markets_Tooltip:'Each bar shows % of that hotel’s total guests (not cumulative)',
        Competitors_Top_5_Markets:'Competitors’ Top 5 Markets',
        Competitors_Top_5_Markets_Tooltip:'Countries whose guest share is over 10% higher at competitor hotels than at your hotel',
        Source_Filter_Placeholder:'Source: All',
        Source_All_Option:'All sources',
        Market_Overlap:'Market Overlap',
        Dominant_Markets:'Dominant Markets',
        Missed_Opportunities:'Missed Opportunities',
        Average_of_competitors:'Average of competitors',
        echarts2Tooltip:'Share of each hotel’s total guests (not additive):',
        Insight_Box:'Insight Box',
        Insight_Box_text:'Your hotel attracts more Family (32%) and Couple (28%) travelers than competitors, while having fewer Business guests',
        no_Data_Tooltip:'This hotel does not have data related to this category for the selected period.',
        Sentiment_Evolution:'Sentiment Score Trend',
        competitor_avg:'Competitor Avg',
        ScoreTrend_Compare:'Compare',
        ScoreTrend_None:'None',
        ScoreTrend_PreviousPeriod:'Previous Period',
        ScoreTrend_LastMonth:'Last Month',
        ScoreTrend_SamePeriodLastYear:'Same Period Last Year',
        ScoreTrend_CustomRange:'Custom Range',
        ScoreTrend_CurrentRange:'Current Range',
        ScoreTrend_CompareRange:'Compare Range',
        ScoreTrend_Current:'Current',
        ScoreTrend_CompareSeries:'Compare',
        ScoreTrend_ScoreBelowThreshold:'Score < Threshold',
        ScoreTrend_CurrentAvg:'Current Avg',
        ScoreTrend_CompareAvg:'Compare Avg',
        ScoreTrend_Difference:'Difference',
        ScoreTrend_PercentChange:'Percent Change',
        ScoreTrend_NoComparisonData:'No comparison data',
        ScoreTrend_VsPreviousPeriod:'vs Previous Period',
        ScoreTrend_VsLastMonth:'vs Last Month',
        ScoreTrend_VsLastYear:'vs Last Year',
        ScoreTrend_VsCustomRange:'vs Custom Range',
        ScoreTrend_LastMonthNote:'Avg based on the full calendar month; the trend shows overlapping days only.',
        ScoreTrend_Apply:'Apply',
        ScoreTrend_Back:'Back',
        // 评论证据抽屉（CompetitorCategoryDrawer）里按大类分组的短名
        topicShort:{
            Location:'Location',
            Cleanliness:'Cleanliness',
            Room:'Room',
            Atmosphere:'Atmosphere',
            FB:'F & B',
            Service:'Service',
            Value:'Value',
            Other:'Other',
        },
    },
    StaffManagement:{
        title:'Staff management',
        addStaff:'Add staff',
        email:'Email',
        username:'Username',
        name:'Name',
        role:'Role',
        status:'Status',
        actions:'Actions',
        editRoles:'Edit roles',
        edit:'Edit',
        // 手机列表「更多」菜单：只能查看的账号（集团账号、自己）用这个代替「编辑」
        viewDetails:'View details',
        department:'Department',
        departmentPlaceholder:'Select a department',
        allDepartments:'All departments',
        post:'Post',
        postPlaceholder:'Enter post (e.g. Front Office Manager)',
        suspend:'Suspend',
        delete:'Delete',
        active:'Active',
        suspended:'Suspended',
        confirmSuspendTitle:'Suspend this staff member?',
        confirmSuspendBody:'They will no longer be able to sign in. You can re-enable them at any time.',
        confirmDeleteTitle:'Remove from this property?',
        confirmDeleteBody:'They will lose access to this property. This cannot be undone.',
        cancel:'Cancel',
        confirm:'Confirm',
        save:'Save',
        emailPlaceholder:'e.g. name@yourhotel.com',
        rolesPlaceholder:'Select role(s)',
        searchPlaceholder:'Search name, email or role',
        statusAll:'All',
        noStaff:'No staff yet',
        addSuccess:'Added successfully',
        suspendSuccess:'Suspended',
        deleteSuccess:'Removed',
        rolesUpdateSuccess:'Roles updated',
        loadFailed:'Failed to load. Please try again.',
        emailRequired:'Please enter an email',
        invalidEmail:'Please enter a valid email address, e.g. name@yourhotel.com',
        emailExists:'This email is already on your staff list',
        addFailed:'Couldn\'t add this staff member. Please try again.',
        actionFailed:'Something went wrong. Please try again.',
        currentUser:'Signed in as',
        you:'You',
        cannotChangeSelf:'You can\'t change, suspend or delete your own account',
        lastAdmin:'Keep at least one active admin on this property',
        noPermissionTitle:'Only admins can manage staff',
        noPermissionDesc:'Ask an admin of this property to add or change staff.',
        updateSuccess:'Saved',
        rolesRequired:'Please select a role',
        staffTitle:'Staff',
        peopleCount:'{n} person | {n} people',
        inviteStaff:'Invite staff',
        sendInvite:'Send invite',
        saveChanges:'Save changes',
        close:'Close',
        removeFromProperty:'Remove from property',
        permissionsCount:'{n} permissions',
        whatRoleCanDo:'What {role} can do',
        compareRoles:'Compare roles',
        currentRole:'Current role: {role}. Pick a role above to change it.',
        noRoles:'No roles available',
        rolesTitle:'Roles and permissions',
        rolesIntro:'What each role can do on this property.',
        permissionsIncluded:'Permissions included',
        included:'Included',
        notIncluded:'Not included',
        scope:'Scope',
        lastLogin:'Last login',
        scopeProperty:'This property',
        scopeBrand:'Brand',
        scopePortfolio:'Portfolio',
        groupTag:'Group',
        groupCount:'{n} group account | {n} group accounts',
        groupNote:'Group accounts cover more than one property. They are set up by Where to know and are read-only here.',
        // 集团账号详情抽屉（只读）
        accessibleProperties:'Properties they can access',
        propertyCount:'{n} property | {n} properties',
        propertyListPending:'The list of properties is not available yet.',
        neverActive:'Never',
        // 同一组几个权限之间的分隔符
        listSeparator:', ',
        // 权限显示名，键是权限代码（后端 labelEn / labelZh 是技术名，这里写给酒店用户看的说法）
        perm:{
            READ_DASHBOARD:'View overview',
            READ_REVIEW:'View reviews',
            READ_NEED_ATTENTION:'View cases',
            MANAGE_NEED_ATTENTION:'Handle cases',
            READ_REPLY_LIBRARY:'View reply library',
            MANAGE_REPLY_LIBRARY:'Edit reply library',
            READ_REPLY:'View reply settings',
            MANAGE_REPLY:'Edit reply settings',
            READ_COMPETITORS:'Competitor overview',
            READ_COMPETITORS_REVIEW:'Competitor reviews',
            READ_REPORT:'View reports',
            EXPORT_REPORT:'Download report PDF',
            EXPORT_REPORT_EXCEL:'Export data (Excel)',
            READ_SURVEY:'View surveys',
            MANAGE_SURVEY:'Handle surveys',
            AI_CHAT:'AI chat',
            READ_GOAL:'View goals',
            MANAGE_GOAL:'Edit goals',
            MANAGE_OVERALL_SETTING:'Notifications',
            WEBSITE_WIDGET:'Website widget',
            READ_STAFF:'View staff',
            MANAGE_STAFF:'Staff management',
            MANAGE_DEPT:'Department management',
        },
        // 角色名，键是角色代码 _STAFF_ 后面那段（德 / 意界面也用英文名）
        roleName:{
            ADMIN:'Admin',
            MANAGER:'Manager',
            GUEST_RELATIONS:'Guest Relations',
            VIEWER:'Viewer',
        },
        // 权限分组（/staff/roles 的 groupName）的显示名
        groups:{
            Overview:'Overview',
            Reviews:'Reviews',
            Cases:'Case management',
            Replies:'Reply settings',
            Competition:'Competition',
            Reports:'Reports',
            Surveys:'Surveys',
            Other:'Intelligence',
            Goals:'Goals',
            Settings:'Settings',
            Staff:'Staff',
        },
    },
    Departments:{
        title:'Departments',
        addDepartment:'Add department',
        editDepartment:'Edit department',
        addSub:'Add sub-department',
        edit:'Edit',
        delete:'Delete',
        name:'Department name',
        namePlaceholder:'Enter department name',
        parent:'Parent department',
        topLevel:'None (top level)',
        manager:'Manager',
        managerPlaceholder:'Select a manager',
        updatedBy:'Last updated by',
        actions:'Actions',
        noDepartments:'No departments yet',
        cancel:'Cancel',
        confirm:'Confirm',
        save:'Save',
        confirmDeleteTitle:'Delete this department?',
        confirmDeleteBody:'This cannot be undone.',
        confirmDeleteBodyWithChildren:'This department has sub-departments. Deleting it cannot be undone.',
        addSuccess:'Department added',
        updateSuccess:'Department updated',
        deleteSuccess:'Department deleted',
        loadFailed:'Failed to load. Please try again.',
        saveFailed:'Operation failed. Please try again.',
        nameRequired:'Please enter a department name',
    },
    Settings:{
        title:'Settings',
        left1:'User',
        left2:'Goals',
        left3:'Notifications',
        left4:'Widget',
        left5:'Connections',
        left6:'Staff',
        left7:'Departments',
        left8:'Roles and permissions',
        left9:'Focus Topics',
        teamGroup:'Team',
        Widget:{
            title:'Review Widget',
            desc:'Embed your WTK review scores on any website. Clients paste one script tag — no other dependencies required.',
            activeWidgets:'Active widgets',
            createNew:'Create new widget',
            style:'Style',
            styleCompact:'Footer / badge',
            styleHorizontal:'Hero strip',
            styleCard:'Full categories',
            styleDark:'Dark overlay',
            period:'Review period',
            period3m:'Last 3 months',
            period12m:'Last 12 months',
            periodAll:'All time',
            brandColor:'Brand color',
            custom:'Custom color',
            domains:'Allowed domains',
            domainsHint:'Leave blank to allow all domains.',
            domainsPlaceholder:'e.g. yourhotel.com',
            generate:'Generate embed code',
            readyTitle:'Widget ready',
            readyDesc:'Copy the code below and paste it anywhere in your website\'s <body>.',
            copy:'Copy code',
            copied:'Copied!',
            revoke:'Revoke',
            revokeConfirm:'Revoke this widget? Clients using this embed code will stop seeing the widget.',
            revokeSuccess:'Widget revoked.',
            createError:'Failed to create widget. Please try again.',
            createdAt:'Created',
            platformScores:'Platform scores (OTA)',
            platformScoresHint:'Select platforms to display their individual scores in the widget.',
            categories:'Categories',
            categoriesHint:'Select categories to display. Leave all unchecked to show all available.',
            livePreview:'Live Preview',
            previewNote:'Sample scores — actual scores reflect your hotel\'s data',
            selectAll:'Select all',
            clearAll:'Clear',
            noHotel:'Please select a hotel first.',
        },
        User:{
            label1:'Login details',
            label2:'Change password',
            label3:'Current password',
            label4:'New password',
            label5:'Confirm new password',
            prompt1:'Password requirements:',
            prompt2:'make sure it’s at least 8 characters long ',
            prompt3:'must include a number, a capital letter, and a lowercase letter',
            button1:'Change password',
        },
        Goals:{
            title:'Goals',
            label1:'Category',
            label2:'Score',
            label3:'Goal',
            label4:'Difference',
            label5:'Deadline',
            label6:'Counting down',
            days:"days",
            unsaved:"You have unsaved changes",
            cancel:"Cancel",
            notSet:"Not set",
            setGoal:"Set goal",
            clearGoal:"Clear",
            // 手机宽度紧凑表格：目标值单元格「设置」、编辑行的「保存」
            set:"Set",
            save:"Save",
            goalReference:"Reference value: {value}",
        },
        Notifications:{
            title:'Notifications',
            enableLabel:'Enable Email Notifications',
            enableDesc:'Receive email alerts when selected review conditions are triggered.',
            customAlertTitle:'Focus Topic Alerts',
            customAlertDesc:'Receive an alert when a new review scores one of your focus topics, or a topic under it, below the threshold. Leave empty for no alert.',
            otaAlertTitle:'OTA Score Alerts',
            otaTitle:'OTA Score Thresholds',
            otaDesc:'Receive an alert when a new review score falls below the threshold set for each platform.',
            wtkTitle:'WQI Threshold',
            wtkLabel:'WQI',
            categoryTitle:'Category Score Thresholds',
            riskSignalTitle:'AI Risk Signal Alerts',
            riskSignalDesc:'Receive an alert when WTK detects hidden risk patterns that may not be obvious from the OTA rating alone.',
            ratingDiscrepancy:'Score mismatch',
            ratingDiscrepancyDesc:'Alert when the guest experience described in the review does not match the OTA rating given.',
            negativeOnly:'Negative Only Review',
            negativeOnlyDesc:'Alert when a review contains only negative sentiment with no positive feedback.',
            recipientsTitle:'Notification Recipients',
            emailTitle:'Notification Email Recipients',
            emailPlaceholder:'Enter email address',
            addEmail:'Add email',
            addBtn:'Add',
            cancelBtn:'Cancel',
            saveBtn:'Save settings',
            invalidEmail:'Please enter a valid email address',
            emailExists:'This email has already been added',
            reportRecipientsTitle:'Report Recipients',
            reportEmailTitle:'Report Email Recipients',
            reportEmailDesc:'Choose who receives your periodic performance reports.',
            selectFromStaff:'Select from staff',
            noStaff:'No staff yet',
        },
        // WTK-1019 专属关注：从话题库选；homeCta 是首页没有专属关注时那张卡片的入口
        FocusTopics:{
            title:'Focus Topics',
            intro:'Pick the topics you want to track closely from the Where to Know topic library. A picked topic becomes one of your focus topics on the Home page and in goals, alerts and filters.',
            noteFromToday:'A picked topic is analysed in new reviews from today on; earlier reviews are not analysed.',
            noteUnpick:'Unpicking a topic stops its analysis; the results so far are kept.',
            notePlaces:'A hotel has up to {max} focus topics. Focus topics set up for you by Where to Know take places too.',
            libraryLabel:'Topic library',
            placesLeft:'{n} place left | {n} places left',
            noPlaceTip:'No place left. Unpick a topic first to pick this one.',
            anchorSub:'Extends {category} › {sub}',
            anchorCategory:'Extends {category}',
            emptyTitle:'The library has no topics yet',
            emptyDesc:'Where to Know is building the topic library. New topics will appear here.',
            loadFailed:'Could not load the topic library',
            retry:'Retry',
            noPermission:'You do not have permission to view the topic library',
            noPermissionSave:'You do not have permission to change focus topics. Please ask your hotel admin.',
            saveRefused:'Could not save: there may be no place left, or a topic is no longer in the library. The page now shows the current state.',
            saveFailed:'Save failed. Please try again later.',
            homeCta:'Pick focus topics',
        },
    },
    Reports:{
        Performance:'Performance',
        Score:'Score',
        Reviews:'Reviews',
        Week1:'Week 1',
        Week2:'Week 2',
        Week3:'Week 3',
        Week4:'Week 4',
        Week5:'Week 5',
        Week6:'Week 6',
        Avg:' Avg',
        Goal:'Goal',
        Above_Goal:'Above Goal',
        Below_Goal:'Below Goal',
        Week_High:'High',
        Week_Low:'Low',
        Week_One:'Week {n}',
        Week_Many:'Weeks {n}',
        Month_Avg:'{month} avg',
        Executive_Summary:'Executive Summary',
        // 手机上长列表默认只显示两条，展开 / 收起；窄图表的横轴周次简写
        Show_All_N:'Show all ({n})',
        Show_Less:'Show less',
        Week_Short:'W{n}',
        Insufficient_Data_Title:'Insufficient Data',
        Insufficient_Data_Reason:'Review count is below the analysis threshold for this period. The report will be generated automatically once the threshold is met.',
        // 酒店月报 Category Insights 下的脚注：月报周分数按当前分析结果重算，可能和当周周报不同（WTK-785）
        Monthly_Weekly_Scores_Note:'This month\'s figures include reviews collected or re-analysed after the weekly reports were sent, so some weekly scores may differ from that week\'s report.',
        competitors:{
            Executive_Competitive_Snapshot:'Executive Competitive Snapshot',
            Market:'Market',
            Competitive_Leverage:'Competitive Leverage',
            Competitive_Pressure:'Competitive Pressure',
            What_Management_Must_Do:'What Management Must Do',
            Relative_Positioning_Strengths_vs_Risks:'Relative Positioning: Strengths vs Risks',
            Top_Competitive_Observations:'Top Competitive Observations',
            Top_5_Positives: 'Top Positives',
            Top_5_Negatives: 'Top Negatives',
            Reason: 'Reason',
            Competitive_Dimensions:'Competitive Dimensions',
            Share_Trigger_Landscape:'Share Trigger Landscape',
            Operational_Challenges:'Operational Challenges',
            Competitor_Patterns:'Competitor Patterns',
            Overview:'Overview',
            Wins:'Wins',
            Learning_Value:'Learning Value',
            Frictions:'Frictions',
            Risk_Relevancy:'Risk Relevancy',
            Top_Mentions:'Top Mentions',
            Food_Mentions:'Food Mentions',
            Beverage_Mentions:'Beverage Mentions',
            Cross_Competitor_Analysis:'Cross-Competitor Analysis',
            Cross_Competitor_Patterns:'Cross-Competitor Patterns',
            Category_Summary:'Category Summary',
            Case_study_of_the_month:'Case study: ',
            Case_study_of_the_month_tooltip:'The competitor that stands out most in this category - either significantly stronger or weaker than the rest of the set.',
            Case_study:'Case study',
            Guest_Desire:'Guest Desire',
            Execution:'Execution',
            Takeaway:'Takeaway',
            Best_practice:'Best practice',
            Staff_Shortages:'Staff Shortages',
            Outdated_Systems:'Outdated Systems',
            High_Guest_Expectations:'High Guest Expectations',
            Action_Focus:'Action Focus',
            Experience_Strengths:'Experience Strengths',
            Experience_Constraints:'Experience Constraints',
            Guest_Attention_Triggers:'Guest Attention Triggers',
            Guest_Attention_Triggers_h2:'These elements disproportionately influence guest perception and sharing',
            Guest_Attention_Triggers_empty:'No guest attention triggers were identified for this property this period.',
            Report_Generating:'This hotel\'s report for this period is being generated. It will appear here automatically.',
            Report_Stalled:'This report is taking longer than usual. Check back in a few minutes.',
            Report_Failed:'Couldn\'t load this hotel\'s report.',
            Restaurant_Detail:'Restaurant Detail',
        },
        MoM:{
            title:'Month-over-Month Tracking',
            lastMonth:'Last Month',
            thisMonth:'This Month',
            monitorClosely:'Monitor Closely',
            badge_new:'New',
            badge_resolved:'Signal Cleared',
            badge_recurring:'Recurring',
            month_apr:'Apr',
            month_mar:'Mar',
            tracking_mock_1:'Afternoon tea food described as so-so; guests expected a clearer premium cue for the price point.',
            tracking_mock_2:'Reception welcome experience inconsistent during peak check-in windows.',
            tracking_mock_3:'Outdoor or semi-outdoor seating occasionally affected by noise or draft — sentiment improved after signage and layout tweaks.',
            tracking_mock_4:'Isolated report of delayed prepaid takeaway — one-off operational gap, not a recurring pattern.',
            action_title:'Action Resolution Tracking',
            col_current_signal:'Current Signal',
            col_last_action:'Last Month Action',
            effective:'Effective',
            low_confidence:'low confidence',
            confidence_medium:'medium confidence',
            confidence_high:'high confidence',
            empty_column:'Not observed in this period.',
            empty_solution:'No solution tracking rows.',
            action_signal_1:'Issue no longer appears in guest feedback.',
            action_last_1:'Isolated incident — review takeaway workflow and confirm prep-time SLAs with the team.',
            action_signal_2:'Positive mentions stable; no new negative clusters in written reviews.',
            action_last_2:'Briefing held with F&B on afternoon tea presentation and pacing between courses.',
            hotel_col_recurring:'Recurring Issues ({n})',
            hotel_col_declined:'Declined Complaints ({n})',
            hotel_col_new:'New Concerns ({n})',
            hotel_rank_n:'Rank {n}',
            hotel_mock_breakfast:'Breakfast',
            hotel_mock_restaurant:'Restaurant',
            hotel_mock_checkin:'Check-in',
            hotel_mock_elevator:'Elevator',
            hotel_mock_billing:'Billing',
            hotel_mock_price_fit:'Experience matching price',
            hotel_recurring_b_apr:'Warm items timing inconsistent; guests still mention queue at peak.',
            hotel_recurring_b_mar:'Several comments on buffet replenishment lag during rush.',
            hotel_recurring_r_apr:'Dinner service pacing mentioned again; noise near open kitchen.',
            hotel_recurring_r_mar:'Similar thread on reservation handoff and seating wait.',
            hotel_declined_ci_mar:'Queue and ID-scan friction down after dedicated express lane.',
            hotel_declined_el_mar:'Wait-time complaints rare after priority service contract fix.',
            hotel_new_b_apr:'New cluster on minibar and city tax line items on folio.',
            hotel_new_p_apr:'Guests question whether room product matches rate tier this month.',
            hotel_solution_title:'Solution Tracking',
            hotel_sol_th_category:'Category',
            hotel_sol_th_action:'Action & details',
            hotel_sol_th_outcome:'Outcome',
            hotel_not_resolved:'Not Resolved',
            still_observed:'Still Observed',
            failure_type_label:'Issue key',
            hotel_sol_parent_location:'Location & Neighbourhood',
            hotel_sol_sub_accessibility:'Accessibility',
            hotel_sol_1_mar:'Wayfinding signage updated at main entrance; briefed door team on escort offers.',
            hotel_sol_1_apr:'Follow-up: fewer written mentions of unclear routes; monitor airport-transfer pickup cues.',
            hotel_sol_parent_fb:'F & B',
            hotel_sol_sub_breakfast:'Breakfast operations',
            hotel_sol_2_apr:'Staggered buffet restock checklist; added runner during 7–9 a.m. peak.',
            hotel_sol_parent_billing:'Billing & Payments',
            hotel_sol_sub_invoice:'Invoice accuracy',
            hotel_sol_3_apr:'Still seeing sporadic duplicate charge disputes; finance reviewing PMS posting rules.',
        },
        Export_Pdf:'Export Pdf',
        Lang_Fallback:'This hotel has no {want} report yet, so it is shown in {shown}.',
        Export_Pdf_Generating:'This period\'s report is still being generated. Please try again in a few minutes.',
        Export_Pdf_Unavailable:'The PDF for this period can\'t be generated right now. Please try again later.',
    },
    Brand_Overview:{
        title:'Brand Overview',
        // Portfolio Insights（BrandOverview2）各竞品模块的空状态：接口没给竞品就只显示这一句，不补任何数字（WTK-753）
        noCompetitorData:'No competitor data yet',
        All_hotels:'All Hotel',
        Portfolio_Brand:'Portfolio / Brand',
        All_Brands:'All Brands',
        Selected_hotels:'Selected hotel',
        Hotel_information:'Hotel information',
        Country:'Country',
        Area:'Area',
        Address:'Address',
        Stars:'Stars',
        Number_of_rooms:'Number of rooms',
        Status_Open:'Open',
        Status_Opening:'Opening Soon',
        Ranking:{
            text1:'Overall average score',
            text2:'APAC average score',
            text3:'EMEA (europe) average score',
            text4:'N. America average score',
            text5:' Overall Score',
            text6:' Hotel Score',
            text7:'Global Ranking',
            text8:'Regional Ranking',
            average_score:'Avg. Score',
        },
        Map_view:'Global Overview',
        Competitor_score_of_OTA_platforms:'OTA Scores Overview',
        Total_reviews:'Total Reviews',
        Marriott_Member_Status_Performance:'Marriott Member Status Performance',
        Room_nights:'Room nights',
        Reviews:'Reviews',
        Review_Rate:'Review Rate',
        Status:'Status',
        Avg_Score:'Avg. Score',
        Recommend:'Recommend',
        Ambassador:'Ambassador',
        Titanium:'Titanium',
        Platinum:'Platinum',
        Gold:'Gold',
        Silver:'Silver',
        Member:'Member',
        Club:'Club Member',
        SilverElite:'Silver Elite',
        GoldElite:'Gold Elite',
        PlatinumElite:'Platinum Elite',
        DiamondElite:'Diamond Elite',
        Customer_Journey:'Customer Journey',
        Date:'Date',
        NovemberAvg:'November Avg.',
        RegionalAvg:'Regional Avg.',
        Global_Average:'Global Average',
        Regional_Average:'Regional Average',
        Brand_consistency:'Brand consistency',
        Regional_City_Segmentation_Ranking_List:'Regional/City Segmentation Ranking List',
        Rank:'Rank',
        Hotel:'Hotel',
        Total_score:'Total score',
        Brand_Consistency_Score:'Brand Consistency Score',
        Global_Brand_Alignment_Ranking:'Global Brand Alignment Ranking',
        Local_Cultural_Expression_Ranking:'Local Cultural Expression Ranking',
        Innovation_Ranking:'Innovation Ranking',
        Elite_Recognition_Ranking:'Elite Recognition Ranking',
        Intention_to_Recommend_Ranking:'Intention to Recommend Ranking',
        CategoryLabel:[
            {
                name:"Location",
                icon:icon_Location,
                value:"Location",
            },
            {
                name:"Cleanliness",
                icon:icon_Cleanness,
                value:"Cleanness",
            },
            {
                name:"Room",
                icon:icon_Room,
                value:"Room",
            },
            {
                name:"Amenities",
                icon:icon_Amenities,
                value:"Amenities",
            },
            {
                name:"F & B",
                icon:icon_FB,
                value:"F & B",
            },
            {
                name:"Service",
                icon:icon_Service,
                value:"Service",
            },
            {
                name:"Value",
                icon:icon_Value,
                value:"Value",
            },
            {
                name:"Brand",
                icon:icon_Brand,
                value:"Brand",
            },
        ],
        Over_score:'Over score',
    },
    likeTemplate:{
        total:'Total',
        dialogText:'Are you sure you want to cancel the bookmark',
        btn1:'Cancel',
        btn2:'Confirm',
        Default_reply:'Default reply',
        ScoreTemplate:{
            h1:'Automatically select the corresponding reply text based on the score (1-10 points)',
            h1Restaurant:'Automatically select the corresponding reply text based on the score (1-5 points)',
            h2:'Each score can be customized individually. Changes apply only to the selected score.',
            Default:'Default',
            Edit:'Edit',
            Reset_to_default:'Reset to default',
            Cancel:'Cancel',
            Save:'Save',
            Title:'Title',
            Start:'Start',
            Main_Body:'Main Body',
            Ending:'Ending',
        },
        Collecting_Reviews:'Collecting Reviews',
    },
    Survey:{
        title:'Survey',
        pageTitle:'Surveys Center',
        overview:'Overview',
        duringStay:'During Stay',
        postStay:'Post Stay',
        mainIssuesTop3:'Main Issues Top 3',
        sentimentSplit:'Sentiment Split',
        aiInsightSummary:'AI Insight Summary',
        topPositives:'Top Positives',
        topNegatives:'Top Negatives',
        responses:'responses',
        avg:'Avg',
        tickets:'tickets',
        insights:'insights',
        recommend:'Recommend',
        needAttention:'need attention',
        urgent:'urgent',
        goal:'Goal',
        vsLastPeriod:'vs last period',
        urgentOnly:'Urgent only',
        department:'Department',
        addNotes:'+ Add Notes',
        total:'Total',
        selectStaff:'Select staff',
        searchStaff:'Search staff..',
        noStaffFound:'No staff found',
        resolve:'Resolve',
        showMore:'Show More',
        reviewDate:'Review date',
        assignedJustNow:'Assigned just now',
        resolvedJustNow:'Resolved just now',
        assign:'Assign',
        reassign:'Reassign',
        positive:'Positive',
        neutral:'Neutral',
        negative:'Negative',
        tab_all:'All',
        tab_unresolved:'Unresolved',
        tab_assigned:'Assigned',
        tab_resolved:'Resolved',
        badge_urgent:'Urgent',
        badge_inProgress:'In Progress',
        badge_pending:'Pending',
        badge_done:'Done',
        badge_notNeeded:'Not Needed',
        dept_all:'All',
        dept_housekeeping:'Housekeeping',
        dept_fb:'F&B',
        dept_frontDesk:'Front Desk',
        dept_concierge:'Concierge',
        cat_room:'Room',
        cat_service:'Service',
        cat_fb:'F&B',
        metric_locationNeighborhood:'Location & Neighbourhood',
        metric_cleanliness:'Cleanliness',
        metric_roomComfort:'Room Comfort',
        metric_hotelAmenitiesAtmosphere:'Hotel Amenities & Atmosphere',
        metric_foodBeverage:'Food & Beverage',
        metric_guestExperienceService:'Guest Experience & Service',
        metric_valueForMoney:'Value for Money',
        resolveOpt_done_title:'Done',
        resolveOpt_done_sub:'Issues resolved',
        resolveOpt_notNeeded_title:'Not Needed',
        resolveOpt_notNeeded_sub:'No action needed',
        time_minsAgo:'{n} mins ago',
        time_yesterday:'Yesterday',
        time_daysAgo:'{n} days ago',
        time_resolvedOn:'Resolved {date}',
        time_assignedNMinsAgo:'Assigned {n} mins ago',
        room:'Room',
        guest:'Guest',
        visitor:'Visitor',
    },
    SurveyPostStay:{
        overallScore:'Hotel Standalone Score',
        hotelStandaloneScore:'Hotel Standalone Score',
        yourHotelOverall:'Your Hotel Overall',
        scoreRate:'Survey Engagement',
        responseRatio:'Response rate',
        recommendRateTitle:'Intention to Recommend',
        completionRate:'Completion Rate',
        completionStats:'{completed} completed • {incomplete} incomplete',
        managementResponseRate:'Management Response Rate',
        replyStats:'{replied} replied • {pending} pending',
        surveyQualityByCountries:'Survey Quality by Countries',
        surveyQualityByLanguage:'Survey Quality by Language',
        received:'Received',
        unreceived:'Unreceived',
        recommend:'Recommend',
        doNotRecommend:'Do Not Recommend',
        scoreLe6:'Score ≤ 6',
        scoreEq7:'Score = 7',
        scoreEq8:'Score = 8',
        scoreGe9:'Score ≥ 9',
        mentions:'mentions',
        sampleSize:'n={n}',
        categoryShareTooltip:'Share of total survey responses rated in this category.',
        top10Countries:'Top 10 countries',
        top10Language:'Top 10 language',
        colRank:'Rank',
        colCountry:'Country',
        colLanguage:'Language',
        colScore:'Score',
        colRecommend:'Recommend',
        colNumber:'Number',
        colReceived:'Received',
        cat_checkIn:'Check-in experience',
        cat_cleanliness:'Cleanliness',
        cat_roomComfort:'Room comfort',
        cat_breakfast:'Breakfast',
        cat_diningBar:'Dining & Bar',
        cat_facilities:'Facilities & Amenities',
        cat_staffService:'Staff & Service',
        cat_checkOut:'Check-out experience',
        reviewsBySubcategory:'Reviews by subcategory',
        colSubcategory:'Subcategory',
        colRatingCount:'Count',
        colReviewCount:'Comments',
        colScoreShare:'Score distribution',
        filterExcellent:'Excellent',
        filterGood:'Good',
        filterAverage:'Average',
        filterBad:'Bad',
        noSubcategoryData:'No subcategory data',
        reviewDate:'Review date',
        showMore:'Show more',
        showLess:'Show less',
        noCommentReviews:'No reviews with comments',
        metaRoomType:'Room type',
        metaCheckIn:'Check-in',
        metaCheckOut:'Check-out',
        metaMembership:'Membership level',
    },
    SurveyDetail:{
        pageTitle:'Responses',
        crumb:'Post-stay survey · Individual raw responses (source records behind aggregated insights; can be opened from any mention in Insights)',
        time24h:'Last 24h',
        timeWeek:'This week',
        timeMonth:'This month',
        filterScoreAll:'All scores',
        filterScoreLow:'≤6 Negative',
        filterScoreMid:'7 Neutral',
        filterScoreHigh:'≥8 Positive',
        filterStatusAll:'All statuses',
        filterStatusNew:'Pending',
        filterStatusDone:'Read',
        filterTextAll:'Text filter',
        filterTextYes:'With text',
        filterTextNo:'Score only',
        responseCount:'{n} responses',
        colSubmitted:'Submitted',
        colGuest:'Guest',
        colChannel:'Channel',
        colRoom:'Room type',
        colNights:'Nights',
        colScore:'Score',
        colRecommend:'Recommend',
        colCheckIn:'Check-in',
        colCheckOut:'Check-out',
        colMemberLevel:'Member level',
        colReplyStatus:'Reply status',
        colText:'Text',
        colStatus:'Status',
        recommendYes:'Yes',
        recommendNo:'No',
        replyUnreplied:'Reply',
        replyReplied:'Replied',
        textSegments:'{n} segments',
        statusNew:'Pending',
        statusDone:'Read',
        listHint:'Click any row to view the full response · Pending = contains negative text or GM note and needs follow-up',
        backToList:'Back to Responses list',
        part1Title:'Part 1 · Overall satisfaction',
        part2Title:'Part 2 · Guest-selected focus dimensions · Dimension scores + sub-items (structured ratings)',
        part3Title:'Part 3 · Other selected dimensions · Dimension scores + sub-items (structured ratings)',
        overallScoreLabel:'Overall Score',
        solvedLabel:'Solved',
        dimEvaluation:'Dimension evaluation',
        notesToManager:'Notes to manager',
        summaryTitle:'Summary',
        prevResponse:'Previous',
        nextResponse:'Next',
        metaCountry:'Country',
        q1Label:'Q1 · Overall satisfaction',
        q2Label:'Q2 · Guest-selected focus dimensions (original selection, not extracted)',
        q3Label:'Q3 · Dimension scores + sub-items (structured ratings)',
        q4Label:'Free text + AI extraction (auditable layer)',
        noAspects:'(none selected)',
        aiExtraction:'AI extraction results',
        sentimentNeg:'Neg',
        sentimentPos:'Pos',
        noFailureType:'(positive · no failure_type)',
        confidence:'Confidence {n}%',
        noFreeText:'This response has no free text.',
        submittedAt:'Submitted {ts}',
        metaChannel:'Channel',
        metaRoom:'Room type',
        metaNights:'Nights',
        nightsUnit:'{n} nights',
        metaScore:'Overall score',
        metaRecommend:'Recommend',
        metaExtractions:'Text extractions',
        yes:'Yes',
        no:'No',
        issueResolvedTitle:'Issue resolved?',
        issueResolvedYes:'Guest reported resolved',
        issueResolvedNo:'Guest reported not resolved',
        guestPerceived:'guest-perceived · not factual',
        gmNoteTitle:'Note to GM (direct commitment)',
        markRead:'Mark as read',
        assignFollowUp:'Assign follow-up',
        waitingForReply:'Waiting for reply',
        aiReplyTitle:'AI reply',
        aiLangPlaceholder:'Select language',
        aiTranslation:'Translation',
        aiGenerate:'Generate',
        aiEdit:'Edit',
        aiSend:'Send',
        specificReply:'Specific Reply',
        detailHint:'Yellow highlights = AI-identified extractable fragments; right panel shows failure_type + dimension + confidence. Unmatched registry entries fall to NEW without force-fit. This page is the auditable layer behind AI extraction — every tag in Insights can be traced back to the original sentence here.',
    },
    StaffTickets:{
        Kind_reviews:'Review cases',
        Kind_staff:'Staff reports',
        Detail_title:'Staff report #{id}',
        Report:'Report',
        Status:'Status',
        Priority:'Priority',
        Category:'Category',
        Owner:'Owner',
        Reported_by:'Reported by',
        Reported_on:'Reported on',
        Days_open:'Days open',
        Date_from:'From',
        Date_to:'To',
        Search:'Search reports',
        Reset:'Reset',
        Open:'Open',
        Under_Review:'In Review',
        Actioned:'Actioned',
        Closed:'Closed',
        High:'High',
        Medium:'Medium',
        Low:'Low',
        No_priority:'No priority',
        Unassigned:'Unassigned',
        Owners_failed:'Could not load team members.',
        No_owners:'No team members',
        Photo_report:'Photo report',
        Photo_failed:'Could not load this photo.',
        Handling:'Handling',
        Note:'Note',
        Note_cleared:'(cleared)',
        Remark:'Remark',
        History:'History',
        History_created:'Report created',
        Save:'Save',
        Saved:'Saved',
        Save_failed:'Could not save. Please try again.',
        Close:'Close',
        Retry:'Retry',
        Load_failed:'Could not load staff reports',
        Empty_title:'No staff reports',
        Empty_body:'Issues your team reports from the hotel will appear here.',
        No_results:'No reports match these filters',
    },
    NeedsAttention:{
        Search_reviews_or_notes:'Search reviews or notes',
        Review_Date:'Date',
        Status:'Status',
        Priority:'Priority',
        Attention:'Attention',
        More_filters:'More filters',
        filters:'filters',
        Source:'Source',
        OTA_Source:'OTA Source',
        Affected_Areas :'Affected Areas ',
        Days_since_posted:'Days since posted',
        Days:'Days',
        OTA_Score:'Score',
        days:'days',
        Reset:'Reset',
        Apply:'Apply',
        WTK_Score:'WQI',
        Attention_Reason:'Attention Reason',
        'Under Review':'Under Review',
        Under_Review:'In Review',
        Open:'Open',
        Closed:'Closed',
        Actioned:'Actioned',
        All:'All',
        show_All:'Show all',
        High:'High',
        Medium:'Medium',
        Low:'Low',
        AutoAlert:'Auto Alert',
        Extremely_Negative:'Extremely Negative',
        Rating_Discrepancy:'Score Mismatch',
        Negative_Only:'Negative Only',
        'Extremely Negative':'Extremely Negative',
        'Rating Discrepancy':'Score Mismatch',
        'Negative Only':'Negative Only',
        Extremely_Negative_Tip:'OTA score below 7/10 (or 3.5/5)',
        Rating_Discrepancy_Tip:'OTA and sentiment scores differ by 2+ points',
        Negative_Only_Tip:'Only negative feedback, no positives identified',
        Total:'Total',
        Key_Metrics:'Key Metrics',
        Guest_Rating:'Guest Rating',
        Days_Since:'Days since post',
        Guest_Review:'Guest Review',
        Summary:'Summary',
        Negative_Summary:'Summary',
        Management_Note:'Note',
        Edit:'Edit',
        Action:'Action',
        Save:'Save',
        Show_more:'Show more',
        Show_Less:'Show Less',
        startTime:'Start',
        endTime:'End',
        Last_updated_date:'Last updated date',
        History:'History',
        History_empty:'No changes yet.',
        History_load_failed:'Could not load the history.',
        History_retry:'Retry',
        History_created:'Added to Case Management',
        History_note_cleared:'(cleared)',
        History_remark:'Remark',
        No_reviews1:'No active attention items',
        No_reviews2:'New reviews with notes requiring action will appear here.',
        dialogTitle:'Remove this item from the list',
        dialogText:'This will permanently delete the item and its notes',
        Cancel:'Cancel',
        Delete:'Delete',
        drawerMessage:'Note cannot be empty',
        Reply_column:'Replied',
        Reply_status:'Reply status',
        Replied:'Replied',
        Not_replied:'Not replied',
        Reply_title:'Reply',
        Reply_date:'Reply date',
        Replied_by:'Replied by',
        No_reply_yet:'No reply yet',
        Reply_load_failed:'Could not load the reply.',
        // 手机卡片列表 / 筛选（≤767px）
        Actions:'More actions',
        View_details:'View details',
        No_priority:'No priority',
        Remove_filter:'Remove filter',
        Reset_all:'Reset all',
        Posted_days:'Posted today | Posted 1 day ago | Posted {n} days ago',
        Load_failed1:'Could not load cases',
        Load_failed2:'Check your connection and try again.',
        No_results1:'No matching cases',
        No_results2:'Try a different date range, search or filters.',
    },
    ReplyLibrary:{
        Search_reviews_or_replies:'Search reviews or replies…',
        Affected_Areas:'Affected Areas',
        OTA_Source:'OTA Source',
        Sort:'Sort',
        Sort_by:'Sort by',
        Time_newest_first:'Time (newest first)',
        Time_oldest_first:'Time (oldest first)',
        Score: 'Score',
        OTA_Score1:'OTA Score (high to low)',
        OTA_Score2:'OTA Score (low to high)',
        Saved_Reason:'Saved Reason',
        Use_case:'Use Case',
        tags:'Tags',
        Cancel:'Cancel',
        Save:'Save',
        Discard :'Discard',
        Discard_changes :'Discard changes',
        No_reason_recorded  :'No reason recorded',
        No_use_cases_assigned  :'No use cases assigned',
        You_editing_another_reply:'You’re editing another reply',
        you_tooltip:'Save your changes before switching,or discard them and continue.',
        unLike:'Remove from favorites',
        No_saved1:'No saved replies yet',
        No_saved2:'Save frequently used responses to build a structured reply library.',
        // 手机底部弹层（预设原因 / 使用场景）
        Saved_reason_hint:'Why this reply is worth keeping, so it is easy to find and reuse later.',
        Use_case_hint:'Type a use case and press Enter to add it. You can add several.',
        Unsaved_changes:'You have unsaved changes. Discard them?',
        Keep_editing:'Keep editing',
        Saving:'Saving…',
        Save_failed:'Could not save. Check your connection and try again.',
        Close:'Close',
    },
    FAQ:{
        needHelp:'Need more help?',
        contactUs:'Contact us',
        searchPlaceholder:'Search questions…',
        noMatches:'No matching questions',
    },
    Connections:{
        title:'Connections',
        intro:'Connect your own Google Business Profile and Tripadvisor listing to WhereToKnow.',
        googleDesc:'Sign in with the Google account that owns or manages this property\'s Business Profile, then choose the location.',
        tripadvisorDesc:'Find this property\'s Tripadvisor listing, or paste the link of its Tripadvisor page.',
        connected:'Connected',
        notConnected:'Not connected',
        needsReconnect:'Needs reconnecting',
        chooseLocationStatus:'Choose a location',
        unavailable:'Not available yet',
        connectGoogle:'Connect Google',
        reconnect:'Reconnect',
        chooseLocation:'Choose location',
        changeLocation:'Change location',
        connectTripadvisor:'Connect Tripadvisor',
        changeListing:'Change listing',
        disconnect:'Disconnect',
        viewListing:'View listing',
        signedInAs:'Signed in as {email}',
        chooseGoogleLocation:'Choose the Google location',
        chooseGoogleLocationHint:'These are the Business Profile locations your Google account manages.',
        noGoogleLocations:'This Google account manages no Business Profile location. Reconnect with the account that owns or manages it.',
        searchTripadvisor:'Search Tripadvisor',
        searchPlaceholder:'Property name',
        search:'Search',
        noResults:'No listing found. Try another name or paste the link below.',
        orPasteLink:'Or paste the link of your Tripadvisor page',
        connect:'Connect',
        cancel:'Cancel',
        save:'Save',
        disconnectTitle:'Disconnect {platform}?',
        disconnectBody:'WhereToKnow will stop using this connection. You can connect again at any time.',
        connectedToast:'{platform} connected',
        failed:'Something went wrong. Please try again.',
        notEnabled:'Connections are not enabled for this property yet. Contact us to turn them on.',
        notForBrand:'Select a hotel or restaurant to manage its connections.',
        finishingGoogle:'Finishing the Google connection…',
        backToConnections:'Back to Connections',
        connectAgain:'Connect Google again',
        tripadvisorFromProfile: "This is the Tripadvisor page we collect this property's reviews from. To use another listing, change it here: WhereToKnow checks it before switching.",
        tripadvisorChangePending: "Change requested to {name}. WhereToKnow will check it before switching; until then the listing above stays in use.",
        disconnectBodyTripadvisor: "Only the connection is removed: WhereToKnow keeps collecting this property's Tripadvisor reviews. You can connect again at any time.",
        tripadvisorPendingNote:'Submitted. WhereToKnow will check the listing and confirm it.',
        pendingStatus:'Waiting for confirmation',
        noMatchingGoogleLocation:'None of these Business Profile locations is {name} on Google. Sign in with the Google account that manages {name}, or contact us if it is listed here.',
        useAnotherGoogleAccount:'Use another Google account',
        thisProperty:'This property',
        promptTitle:'Connect your Google Business Profile',
        promptBody:'Link this property\'s Business Profile so WhereToKnow can work with your Google reviews directly.',
        promptAction:'Connect',
        promptDismiss:'Dismiss',
        googleCancelled:'The Google sign-in was cancelled.',
        googleFailed:'Google could not be connected. Please try again.',
        startAgain:'This Google sign-in could not be matched to a property. Please start the connection again.',
    },
    // 读屏用的 aria-label
    A11y:{
        close:'Close',
        openMenu:'Open menu',
        scrollLeft:'Scroll left',
        scrollRight:'Scroll right',
        togglePanel:'Toggle panel',
    },
    // 右下角帮助聊天气泡（components/common/SupportChatbot.vue）。msg 里的 \n 会被渲染成换行
    SupportChatbot:{
        brandStatus:'Support',
        title:'How can we help?',
        subtitle:'Choose a topic or type your question below.',
        placeholder:'Type your question...',
        privacyPrefix:'By chatting you agree to our',
        privacyLink:'Privacy Policy',
        privacySuffix:'',
        contactTitle:'Contact Support',
        contactBody:'Send us a detailed message and we’ll get back to you within 1 business day.',
        noMatch:"I wasn't able to match that. Here are the main options:",
        opt:{
            learnFeature:'Learn about a feature',
            contactSupport:'Contact support team',
            reportIssue:'Report an issue',
            wqi:'WQI',
            hotelOverview:'Hotel Overview',
            hotelCompetitors:'Hotel Competitors',
            restaurantOverview:'Restaurant Overview',
            restaurantCompetitors:'Restaurant Competitors',
            replySetting:'Reply Setting',
            replyLibrary:'Reply Library',
            needsAttention:'Needs Attention',
            reports:'Reports',
            brandOverview:'Brand Overview',
            staffLeaderboard:'Staff Mentions Leaderboard',
            settings:'Settings, Goals & Notifications',
            backToMain:'Back to main menu',
            gotIt:'Got it',
            needMoreHelp:'I need more help',
            back:'Back',
            adjustCompSet:'I’d like to adjust my comp set',
            dataMissing:'Data not loading or missing',
            crashError:'Crash, error, or display issue',
            resolvedIt:'That resolved it',
            stillMissing:'Still missing — email support',
            emailSupport:'Email support team',
            anotherQuestion:'Yes, another question',
            thatsAll:'No, that’s all',
            helpful:'Yes, it was helpful',
            notReally:'Not really',
        },
        msg:{
            start:'What can I help you with today?',
            featureHelp:'Which area would you like to know more about?',
            reportBug:'We’re sorry for the inconvenience. What type of issue are you experiencing?',
            bugData:'For missing or outdated data, please try:\n\n1. Check the Last Updated timestamp — data refreshes every 2–4 hours\n2. Try a different date range\n3. Hard refresh the page (Ctrl+Shift+R / Cmd+Shift+R)\n\nIf data is still missing after 4 hours, our team can investigate.',
            bugOther:'To help us resolve this, please email us with:\n\n• Which page or section\n• What you did right before the issue\n• What you expected vs what happened\n• A screenshot if possible',
            connectHuman:'Our support team is happy to assist. We typically respond within 1 business day.',
            resolved:'Glad that helped. Is there anything else?',
            feedback:'Before you go — was this conversation helpful?',
            feedbackPositive:'Thank you for the feedback. Have a great day.',
            feedbackNegative:"We appreciate your honesty. You can reach our support team directly — they'll be happy to help:",
            library:'The Reply Library is your personal collection of saved review responses.\n\n• Click the heart icon on any reply to save it\n• Each saved reply stores the original review, your response, OTA source, scores, and affected areas\n• Add a “Saved Reason” and “Use Case” tags to organise your collection\n• You can edit saved replies, reasons, and tags at any time\n• Filter by date, OTA source, affected areas, or search by keyword',
            reports:'Reports:\n\n• Available periods: weekly, monthly, quarterly, half-year, and yearly\n• Each report covers category scores, trend overview, management focus, and department-ready action plans\n• Weekly reports refresh every Monday; monthly on the 1st of each month\n• Data Reliability indicator: Green = 50+ reviews (high confidence), Yellow = 10–50, Red = under 10\n• Use ‘Last period’ / ‘Next period’ buttons to compare across periods',
            hotel:{
                wqi:'The WQI is an AI-generated rating (1–10) based on real guest sentiment across all your review platforms.\n\nUnlike simple averages, it analyses the full text and emotional strength of every review across 7 categories: Service, Cleanliness, Rooms, F&B, Amenities, Location, and Value.\n\nScore ranges:\n• 9–10: Exceptional\n• 8–9: Great\n• 7–8: Good\n• 6–7: Improvement needed\n• Below 6: Urgent attention required',
                dashboard:'Hotel Overview at a glance:\n\n• Data refreshes automatically every 2–4 hours\n• Use platform tabs (Booking.com, Google, Expedia…) to filter by source\n• Click any KPI circle to drill into subcategories and individual reviews\n• The Staff Mentions Leaderboard shows which team members guests mention and whether it’s positive or negative\n• The F&B Mentions Leaderboard tracks food and beverage highlights from reviews',
                competitors:'Hotel Competitors:\n\n• Your initial comp set is built by WTK based on location, category, price range, and guest overlap\n• You can request changes to your comp set anytime — updates take 24–48 hours\n• Standard: 5 competitors · Professional: up to 10 · Enterprise: custom\n• All competitor data comes from public OTA and review platforms only',
                reply:'Reply Setting:\n\n• Choose a Brand Preset (Formal Elegant, Premium Warm, Casual Playful, Minimal Neutral) to define your voice\n• Adjust Formality, Contractions, Emoji, and Humour toggles to match your brand\n• Set Language to Auto (replies in the guest’s language) or Fixed\n• Use Smart Replies to auto-insert custom sentences when specific topics are mentioned\n• Set Reply Length: Short (30–60 words) for OTAs, Standard, Detailed, or Dynamic',
                attention:'Needs Attention uses AI Risk Signals to automatically flag reviews that require immediate action.\n\nEach flagged review shows an "Auto Alert" tag plus up to two risk signal tags:\n• Rating–Experience Mismatch — gap between OTA score and WTK analysis\n• Extremely Negative — strong negative sentiment across categories\n• Negative Only Review — no positive aspects at all\n\nFor each review you can set Priority (High / Medium / Low), update Status (Open → Actioned → Closed), and add Management Notes. Days since posting are colour-coded: green (≤3), orange (3–5), red (>5).',
                brand:'Brand Overview provides multi-property insights across your hotel group.\n\n• Global & Regional Rankings — see how each hotel performs within the brand\n• Member Status Performance — how different loyalty tiers rate their stays\n• Brand Consistency & Expression — tracks alignment, local cultural expression, innovation, and recommendation intent\n• Use the map view and region selector to explore properties',
                settings:'Settings, Goals & Notifications:\n\n• Set target scores for each of the 7 KPI categories — the dashboard shows Difference = Actual – Goal in real time\n• Goals can be adjusted anytime and are per-property\n• Notifications: enable email alerts for OTA Score Alerts (per-platform thresholds) and AI Risk Signal Alerts (Rating–Experience Mismatch, Negative Only Review)\n• Trip.com max score is 10 by default, or 5 in Chinese language mode\n• Add multiple email recipients in the Notification Recipients section\n• Login email cannot be changed from Settings — contact your admin or our support team',
            },
            restaurant:{
                wqi:'The WQI is an AI-generated rating (1–10) based on real guest sentiment across all your review platforms.\n\nUnlike simple averages, it analyses the full text and emotional strength of every review across 7 categories: Food Quality, Staff Service, Ambiance, Cleanliness, Value for Money, Allergen Handling, and Overall Experience.\n\nScore ranges:\n• 9–10: Exceptional\n• 8–9: Great\n• 7–8: Good\n• 6–7: Improvement needed\n• Below 6: Urgent attention required',
                dashboard:"Restaurant Overview at a glance:\n\n• Data refreshes automatically every 2–4 hours\n• Use platform tabs (Booking.com, Google, TripAdvisor…) to filter by source\n• Click any KPI circle to drill into subcategories and individual reviews\n• The Staff Mentions Leaderboard shows which team members guests mention and whether it's positive or negative\n• Track food highlights, special requests, and dietary preferences from guest feedback",
                competitors:'Restaurant Competitors:\n\n• Your initial comp set is built by WTK based on cuisine type, location, price range, and guest overlap\n• You can request changes to your comp set anytime — updates take 24–48 hours\n• All competitor data comes from public OTA and review platforms only',
                reply:"Reply Setting:\n\n• Choose a Brand Preset to define your voice (Professional, Warm, Casual, Minimal)\n• Adjust Formality, Contractions, Emoji, and Humour toggles to match your brand\n• Set Language to Auto (replies in the guest's language) or Fixed\n• Use Smart Replies to auto-insert custom responses when cuisine, allergen, or service topics are mentioned\n• Set Reply Length: Short (30–60 words), Standard, Detailed, or Dynamic",
                attention:"Needs Attention uses AI Risk Signals to automatically flag reviews that require immediate action.\n\nEach flagged review shows an 'Auto Alert' tag plus up to two risk signal tags:\n• Score mismatch — gap between OTA score and WTK analysis\n• Extremely Negative — strong negative sentiment across categories\n• Negative Only Review — no positive aspects at all\n\nFor each review you can set Priority (High / Medium / Low), update Status, and add Management Notes.",
                staff:'Staff Mentions Leaderboard:\n\n• Automatically tracks team members mentioned in guest reviews\n• Shows mention count, sentiment (positive / negative), and key feedback\n• Helps identify top performers and recognize excellent service\n• Use the leaderboard to understand which staff members make the biggest impact on guest satisfaction\n• Filter by date range and OTA source',
                settings:'Settings, Goals & Notifications:\n\n• Set target scores for each of the 7 KPI categories — the dashboard shows Difference = Actual – Goal in real time\n• Goals can be adjusted anytime and are per-restaurant\n• Notifications: enable email alerts for OTA Score Alerts and AI Risk Signal Alerts\n• Add multiple email recipients in the Notification Recipients section\n• Login email cannot be changed from Settings — contact your admin or our support team',
            },
        },
    },
    // WTK-913 专属关注卡片
    CustomCategories:{
        retired:'Retired',
        footerLabel:'Mentions',
        footerValue:'{count} of {analysed} reviews',
        general:'Overall',
    },
    // WTK-913 报告里的专属关注
    ReportFocusTopics:{
        reviews:'{n} review | {n} reviews',
        noMentions:'No mentions this period',
        noIssues:'No issues reported',
        trend:'Trend',
        tips:'Tips for {name}',
        quotes:'What guests said',
    },
}
